import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface, initMetadataForClassbxx6q50dy2s7 as initMetadataForClass, initMetadataForObject1cxne3s9w65el as initMetadataForObject, initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine, protoOf180f3jzyo7rfj as protoOf, THROW_CCE2g6jy02ryeudk as THROW_CCE, Unit_instance14hm69wy3kr8u as Unit_instance, isInterface3d6p8outrmvmk as isInterface, IllegalStateException_init_$Create$1nm9y6jd3c9iy as IllegalStateException_init_$Create$_0, toString1pkumu07cwy4m as toString_1, VOID7hggqo3abtya as VOID, get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED, toString30pk9tzaqopn as toString_0, hashCodeq5arwsb9dgti as hashCode, equals2au1ep9vhcato as equals, CancellationException_init_$Create$abblhb9ra5mk as CancellationException_init_$Create$_0, Result__exceptionOrNull_impl_p6xea93g9kuxe56cw2k as Result__exceptionOrNull_impl_p6xea9, _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg, RuntimeException_init_$Create$1uo9cv0rggpzf as RuntimeException_init_$Create$_1, addSuppressedu5jwjfvsc039 as addSuppressed, noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException, startCoroutine327fwvtqvedik as startCoroutine, ArrayDeque_init_$Create$3radqcftj9po2 as ArrayDeque_init_$Create$, Long2qws0ah9gnpki as Long, RuntimeException_init_$Init$2bxjdc47ga271 as RuntimeException_init_$Init$_1, captureStack1fzi4aczwc4hg as captureStack, StringBuilder_init_$Create$zzhi687lupah as StringBuilder_init_$Create$_0, throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException, ArrayList3it5z8td81qkl as ArrayList, CancellationException3b36o9qz53rgr as CancellationException, IllegalStateException_init_$Create$1re2ox2t9owo2 as IllegalStateException_init_$Create$_1, anyToString3ho3k49fc56mj as anyToString, UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException, Companion_getInstance1mc3g3aij23my as Companion_getInstance_16, toDurationba1nlt78o6vu as toDuration_0, DurationUnit_MILLISECONDS_getInstance27okq1lv22wqm as DurationUnit_MILLISECONDS_getInstance, returnIfSuspended1blqheeew1z6h as returnIfSuspended, UnsupportedOperationException_init_$Create$1usmxm8d6ijjz as UnsupportedOperationException_init_$Create$_0, IllegalArgumentException_init_$Create$sfel9vrfa7w2 as IllegalArgumentException_init_$Create$_0, _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8, createFailure8paxfkfa5dc7 as createFailure, Exception_init_$Init$2t8qsqvbxaqim as Exception_init_$Init$_1, intercepted2ogpsikxxj4u0 as intercepted, createCoroutineUnintercepted3gya308dmbbtg as createCoroutineUnintercepted, startCoroutineUninterceptedOrReturnNonGeneratorVersionyfrrvzbtl8bf as startCoroutineUninterceptedOrReturnNonGeneratorVersion, Unitkvevlwgzwiuc as Unit, getKClassFromExpression3vpejubogshaw as getKClassFromExpression, removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull, coerceIn302bduskdb54x as coerceIn, CancellationException_init_$Init$yjd67q19gh18 as CancellationException_init_$Init$_1, getStringHashCode26igk1bx568vk as getStringHashCode, ensureNotNull1e947j3ixpazm as ensureNotNull, RuntimeException_init_$Init$2i94smf8ys3t6 as RuntimeException_init_$Init$_0, LinkedHashSet_init_$Create$161uomhguzhxi as LinkedHashSet_init_$Create$, plusolev77jfy5r9 as plus, get6d5x931vk0s as get, fold36i9psb7d5v48 as fold, minusKeyyqanvso9aovh as minusKey, getxe4seun860fg as get_0, minusKey2uxs00uz5ceqp as minusKey_0, defineProp3hxgpk2knu2px as defineProp, AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement, Key_instance10ebq86xndg52 as Key_instance, Enum3alwj03lh1n41 as Enum, ArrayList_init_$Create$3m1kyiqequwm5 as ArrayList_init_$Create$_0, CancellationException_init_$Init$31woqfgrhq6f4 as CancellationException_init_$Init$_0, CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl, Error_init_$Init$2zp3hflsgcgv as Error_init_$Init$_1, toLongw1zpgk99d84b as toLong, AbstractCoroutineContextKey9xr9r6wlj5bm as AbstractCoroutineContextKey, HashSet_init_$Create$35v8jtxapyyka as HashSet_init_$Create$_1, EmptyCoroutineContext_getInstance2qfbu6z39urjq as EmptyCoroutineContext_getInstance, Duration__isPositive_impl_tvkkt23mvdjuzm9oa9z as Duration__isPositive_impl_tvkkt2, DurationUnit_NANOSECONDS_getInstancecxqydqjcg0ot as DurationUnit_NANOSECONDS_getInstance, _Duration___get_inWholeMilliseconds__impl__msfiryngn8rf3n78he as _Duration___get_inWholeMilliseconds__impl__msfiry, Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f, Exception_init_$Create$1f9k5rt5gytdg as Exception_init_$Create$_0, Element2gr7ezmxqaln7 as Element, Continuation1aa2oekvx7jm7 as Continuation, ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor, RuntimeException1r3t0zl97011n as RuntimeException, Error3ofk6owajcepa as Error_0, Exceptiondt2hlxn7j7vw as Exception, KtMutableList1beimitadwkna as KtMutableList } from './kotlin-kotlin-stdlib.js';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1, atomic$ref$130aurmcwdfdf1 as atomic$ref$1, atomic$int$11d5swdyn6j0pu as atomic$int$1, atomic$long$129k9zwo6n9ogd as atomic$long$1, atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls } from './kotlinx-atomicfu.js';

//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Element], [0]);
initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Element, ParentJob], [0]);
initMetadataForInterface(CoroutineScope, 'CoroutineScope');
initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, JobSupport, [JobSupport, Element, Continuation, CoroutineScope], [0]);
initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, AbstractCoroutine, VOID, [0]);
initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, StandaloneCoroutine, VOID, [0]);
initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, Element], [0]);
initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, DeferredCoroutine, VOID, [0]);
initMetadataForInterface(CancellableContinuation, 'CancellableContinuation', VOID, VOID, [Continuation]);
initMetadataForInterface(Runnable, 'Runnable');
initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
initMetadataForClass(DispatchedTask, 'DispatchedTask', VOID, SchedulerTask);
initMetadataForInterface(Waiter, 'Waiter');
initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, DispatchedTask, [DispatchedTask, CancellableContinuation, Waiter]);
initMetadataForInterface(NotCompleted, 'NotCompleted');
initMetadataForInterface(CancelHandler, 'CancelHandler', VOID, VOID, [NotCompleted]);
initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
initMetadataForClass(CompletedContinuation, 'CompletedContinuation');
initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
initMetadataForInterface(Incomplete, 'Incomplete');
initMetadataForClass(JobNode, 'JobNode', VOID, LockFreeLinkedListNode, [LockFreeLinkedListNode, Incomplete]);
initMetadataForClass(ChildContinuation, 'ChildContinuation', VOID, JobNode);
initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
initMetadataForClass(CancelledContinuation, 'CancelledContinuation', VOID, CompletedExceptionally);
initMetadataForObject(Key, 'Key', VOID, AbstractCoroutineContextKey);
initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, ContinuationInterceptor]);
initMetadataForObject(Key_0, 'Key');
initMetadataForClass(CoroutineStart, 'CoroutineStart', VOID, Enum);
initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
initMetadataForInterface(DelayWithTimeoutDiagnostics, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay], [1]);
initMetadataForClass(EventLoop, 'EventLoop', VOID, CoroutineDispatcher);
initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException', VOID, RuntimeException);
initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError', VOID, Error_0);
initMetadataForObject(Key_1, 'Key');
initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle');
initMetadataForClass(DisposeOnCompletion, 'DisposeOnCompletion', VOID, JobNode);
initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
initMetadataForClass(LockFreeLinkedListHead, 'LockFreeLinkedListHead', LockFreeLinkedListHead, LockFreeLinkedListNode);
initMetadataForClass(NodeList, 'NodeList', NodeList, LockFreeLinkedListHead, [LockFreeLinkedListHead, Incomplete]);
initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
initMetadataForClass(Finishing, 'Finishing', VOID, SynchronizedObject, [SynchronizedObject, Incomplete]);
initMetadataForClass(ChildCompletion, 'ChildCompletion', VOID, JobNode);
initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion', VOID, JobNode);
initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling', VOID, JobNode);
initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, JobNode);
initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
initMetadataForClass(JobImpl, 'JobImpl', VOID, JobSupport, [JobSupport, Element], [0]);
initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher', VOID, CoroutineDispatcher);
initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, JobImpl, VOID, [0]);
initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException', VOID, CancellationException);
initMetadataForClass(ScopeCoroutine, 'ScopeCoroutine', VOID, AbstractCoroutine, VOID, [0]);
initMetadataForClass(TimeoutCoroutine, 'TimeoutCoroutine', VOID, ScopeCoroutine, [ScopeCoroutine, Runnable], [0]);
initMetadataForCoroutine($withTimeoutOrNullCOROUTINE$1, CoroutineImpl);
initMetadataForObject(Unconfined, 'Unconfined', VOID, CoroutineDispatcher);
initMetadataForObject(Key_2, 'Key');
initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
initMetadataForClass(Segment, 'Segment', VOID, ConcurrentLinkedListNode, [ConcurrentLinkedListNode, NotCompleted]);
initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed', VOID, Exception);
initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation', VOID, DispatchedTask, [DispatchedTask, Continuation]);
initMetadataForClass(DispatchException, 'DispatchException', VOID, Exception);
initMetadataForClass(ContextScope, 'ContextScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(_Symbol, 'Symbol');
initMetadataForInterface(SelectInstance, 'SelectInstance');
initMetadataForClass(CancellableContinuationWithOwner, 'CancellableContinuationWithOwner', VOID, VOID, [CancellableContinuation, Waiter]);
initMetadataForClass(SemaphoreAndMutexImpl, 'SemaphoreAndMutexImpl', VOID, VOID, VOID, [0]);
initMetadataForClass(MutexImpl, 'MutexImpl', VOID, SemaphoreAndMutexImpl, VOID, [1, 0]);
initMetadataForClass(SemaphoreSegment, 'SemaphoreSegment', VOID, Segment);
initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue', VOID, MessageQueue);
initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue', VOID, MessageQueue);
initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop, EventLoop);
initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, VOID, [CancelHandler]);
initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout', VOID, ClearTimeout);
initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
initMetadataForObject(Dispatchers, 'Dispatchers');
initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher', VOID, MainCoroutineDispatcher);
initMetadataForClass(JobCancellationException, 'JobCancellationException', VOID, CancellationException);
initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException', VOID, RuntimeException);
initMetadataForClass(ListClosed, 'ListClosed', VOID, LockFreeLinkedListNode);
initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
//endregion
function AbstractCoroutine(parentContext, initParentJob, active) {
  JobSupport.call(this, active);
  if (initParentJob) {
    this.q1e(parentContext.s8(Key_instance_2));
  }
  this.t1e_1 = parentContext.ld(this);
}
protoOf(AbstractCoroutine).z7 = function () {
  return this.t1e_1;
};
protoOf(AbstractCoroutine).u1e = function () {
  return this.t1e_1;
};
protoOf(AbstractCoroutine).v1e = function () {
  return protoOf(JobSupport).v1e.call(this);
};
protoOf(AbstractCoroutine).w1e = function (value) {};
protoOf(AbstractCoroutine).x1e = function (cause, handled) {};
protoOf(AbstractCoroutine).y1e = function () {
  return get_classSimpleName(this) + ' was cancelled';
};
protoOf(AbstractCoroutine).z1e = function (state) {
  if (state instanceof CompletedExceptionally) {
    this.x1e(state.a1f_1, state.c1f());
  } else {
    this.w1e((state == null ? true : !(state == null)) ? state : THROW_CCE());
  }
};
protoOf(AbstractCoroutine).o8 = function (result) {
  var state = this.d1f(toState_0(result));
  if (state === get_COMPLETING_WAITING_CHILDREN()) return Unit_instance;
  this.e1f(state);
};
protoOf(AbstractCoroutine).e1f = function (state) {
  return this.f1f(state);
};
protoOf(AbstractCoroutine).g1f = function (exception) {
  handleCoroutineException(this.t1e_1, exception);
};
protoOf(AbstractCoroutine).h1f = function () {
  get_coroutineName(this.t1e_1);
  {
    return protoOf(JobSupport).h1f.call(this);
  }
};
protoOf(AbstractCoroutine).i1f = function (start, receiver, block) {
  start.l1f(block, receiver, this);
};
function launch(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.n1g() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
  coroutine.i1f(start, coroutine, block);
  return coroutine;
}
function StandaloneCoroutine(parentContext, active) {
  AbstractCoroutine.call(this, parentContext, true, active);
}
protoOf(StandaloneCoroutine).j1g = function (exception) {
  handleCoroutineException(this.t1e_1, exception);
  return true;
};
function LazyStandaloneCoroutine(parentContext, block) {
  StandaloneCoroutine.call(this, parentContext, false);
  this.u1g_1 = createCoroutineUnintercepted(block, this, this);
}
protoOf(LazyStandaloneCoroutine).r1f = function () {
  startCoroutineCancellable(this.u1g_1, this);
};
function async(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.n1g() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
  coroutine.i1f(start, coroutine, block);
  return coroutine;
}
function DeferredCoroutine(parentContext, active) {
  AbstractCoroutine.call(this, parentContext, true, active);
}
protoOf(DeferredCoroutine).y1g = function () {
  var tmp = this.m1g();
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
function LazyDeferredCoroutine(parentContext, block) {
  DeferredCoroutine.call(this, parentContext, false);
  this.c1h_1 = createCoroutineUnintercepted(block, this, this);
}
protoOf(LazyDeferredCoroutine).r1f = function () {
  startCoroutineCancellable(this.c1h_1, this);
};
function CancellableContinuation() {}
function invokeOnCancellation(_this__u8e3s4, handler) {
  var tmp;
  if (_this__u8e3s4 instanceof CancellableContinuationImpl) {
    _this__u8e3s4.n1h(handler);
    tmp = Unit_instance;
  } else {
    throw UnsupportedOperationException_init_$Create$_0('third-party implementation of CancellableContinuation is not supported');
  }
  return tmp;
}
function getOrCreateCancellableContinuation(delegate) {
  if (!(delegate instanceof DispatchedContinuation)) {
    return new CancellableContinuationImpl(delegate, 1);
  }
  var tmp0_safe_receiver = delegate.u1h();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    // Inline function 'kotlinx.coroutines.getOrCreateCancellableContinuation.<anonymous>' call
    if (tmp0_safe_receiver.v1h()) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return new CancellableContinuationImpl(delegate, 2);
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function get_RESUME_TOKEN() {
  _init_properties_CancellableContinuationImpl_kt__6rrtdd();
  return RESUME_TOKEN;
}
var RESUME_TOKEN;
function _get_parentHandle__f8dcex($this) {
  return $this.m1h_1.kotlinx$atomicfu$value;
}
function _get_stateDebugRepresentation__bf18u4($this) {
  var tmp0_subject = $this.o1f();
  var tmp;
  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
    tmp = 'Active';
  } else {
    if (tmp0_subject instanceof CancelledContinuation) {
      tmp = 'Cancelled';
    } else {
      tmp = 'Completed';
    }
  }
  return tmp;
}
function isReusable($this) {
  var tmp;
  if (get_isReusableMode($this.x1h_1)) {
    var tmp_0 = $this.i1h_1;
    tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).w1h();
  } else {
    tmp = false;
  }
  return tmp;
}
function cancelLater($this, cause) {
  if (!isReusable($this)) return false;
  var tmp = $this.i1h_1;
  var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
  return dispatched.y1h(cause);
}
function callSegmentOnCancellation($this, segment, cause) {
  // Inline function 'kotlinx.coroutines.index' call
  var index = $this.k1h_1.kotlinx$atomicfu$value & 536870911;
  // Inline function 'kotlin.check' call
  if (!!(index === 536870911)) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
    var message = 'The index for Segment.onCancellation(..) is broken';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
  try {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
    segment.d1i(index, cause, $this.z7());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException($this.z7(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
    } else {
      throw $p;
    }
  }
}
function trySuspend($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.k1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.trySuspend.<anonymous>' call
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$2 = (1 << 29) + (cur & 536870911) | 0;
        if ($this.k1h_1.atomicfu$compareAndSet(cur, tmp$ret$2)) return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
}
function tryResume($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.k1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResume.<anonymous>' call
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$2 = (2 << 29) + (cur & 536870911) | 0;
        if ($this.k1h_1.atomicfu$compareAndSet(cur, tmp$ret$2)) return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
}
function installParentHandle($this) {
  var tmp0_elvis_lhs = $this.z7().s8(Key_instance_2);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parent = tmp;
  var handle = invokeOnCompletion(parent, VOID, new ChildContinuation($this));
  $this.m1h_1.atomicfu$compareAndSet(null, handle);
  return handle;
}
function invokeOnCancellationImpl($this, handler) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.l1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellationImpl.<anonymous>' call
    var state = this_0.kotlinx$atomicfu$value;
    if (state instanceof Active) {
      if ($this.l1h_1.atomicfu$compareAndSet(state, handler)) return Unit_instance;
    } else {
      var tmp;
      if (!(state == null) ? isInterface(state, CancelHandler) : false) {
        tmp = true;
      } else {
        tmp = state instanceof Segment;
      }
      if (tmp) {
        multipleHandlersError($this, handler, state);
      } else {
        if (state instanceof CompletedExceptionally) {
          if (!state.m1i()) {
            multipleHandlersError($this, handler, state);
          }
          if (state instanceof CancelledContinuation) {
            var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
            var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a1f_1;
            if (isInterface(handler, CancelHandler)) {
              $this.j1i(handler, cause);
            } else {
              var segment = handler instanceof Segment ? handler : THROW_CCE();
              callSegmentOnCancellation($this, segment, cause);
            }
          }
          return Unit_instance;
        } else {
          if (state instanceof CompletedContinuation) {
            if (!(state.f1i_1 == null)) {
              multipleHandlersError($this, handler, state);
            }
            if (handler instanceof Segment) return Unit_instance;
            if (!isInterface(handler, CancelHandler)) THROW_CCE();
            if (state.k1i()) {
              $this.j1i(handler, state.i1i_1);
              return Unit_instance;
            }
            var update = state.l1i(VOID, handler);
            if ($this.l1h_1.atomicfu$compareAndSet(state, update)) return Unit_instance;
          } else {
            if (handler instanceof Segment) return Unit_instance;
            if (!isInterface(handler, CancelHandler)) THROW_CCE();
            var update_0 = new CompletedContinuation(state, handler);
            if ($this.l1h_1.atomicfu$compareAndSet(state, update_0)) return Unit_instance;
          }
        }
      }
    }
  }
}
function multipleHandlersError($this, handler, state) {
  // Inline function 'kotlin.error' call
  var message = "It's prohibited to register multiple handlers, tried to register " + toString_1(handler) + ', already has ' + toString_0(state);
  throw IllegalStateException_init_$Create$_0(toString_1(message));
}
function dispatchResume($this, mode) {
  if (tryResume($this)) return Unit_instance;
  dispatch($this, mode);
}
function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
  var tmp;
  if (proposedUpdate instanceof CompletedExceptionally) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    tmp = proposedUpdate;
  } else {
    if (!get_isCancellableMode(resumeMode) && idempotent == null) {
      tmp = proposedUpdate;
    } else {
      var tmp_0;
      var tmp_1;
      if (!(onCancellation == null)) {
        tmp_1 = true;
      } else {
        tmp_1 = isInterface(state, CancelHandler);
      }
      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = !(idempotent == null);
      }
      if (tmp_0) {
        tmp = new CompletedContinuation(proposedUpdate, isInterface(state, CancelHandler) ? state : null, onCancellation, idempotent);
      } else {
        tmp = proposedUpdate;
      }
    }
  }
  return tmp;
}
function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.l1h_1;
  while (true) {
    var tmp1 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResumeImpl.<anonymous>' call
      if (!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false) {
        var update = resumedState($this, tmp1, proposedUpdate, $this.x1h_1, onCancellation, idempotent);
        if (!$this.l1h_1.atomicfu$compareAndSet(tmp1, update)) {
          break $l$block;
        }
        detachChildIfNonReusable($this);
        return get_RESUME_TOKEN();
      } else {
        if (tmp1 instanceof CompletedContinuation) {
          var tmp;
          if (!(idempotent == null) && tmp1.h1i_1 === idempotent) {
            // Inline function 'kotlinx.coroutines.assert' call
            tmp = get_RESUME_TOKEN();
          } else {
            tmp = null;
          }
          return tmp;
        } else {
          return null;
        }
      }
    }
  }
}
function alreadyResumedError($this, proposedUpdate) {
  // Inline function 'kotlin.error' call
  var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
  throw IllegalStateException_init_$Create$_0(toString_1(message));
}
function detachChildIfNonReusable($this) {
  if (!isReusable($this)) {
    $this.n1i();
  }
}
function CancellableContinuationImpl$resume$lambda($onCancellation) {
  return function (cause, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    $onCancellation(cause);
    return Unit_instance;
  };
}
function CancellableContinuationImpl(delegate, resumeMode) {
  DispatchedTask.call(this, resumeMode);
  this.i1h_1 = delegate;
  // Inline function 'kotlinx.coroutines.assert' call
  this.j1h_1 = this.i1h_1.z7();
  var tmp = this;
  // Inline function 'kotlinx.coroutines.decisionAndIndex' call
  var tmp$ret$0 = (0 << 29) + 536870911 | 0;
  tmp.k1h_1 = atomic$int$1(tmp$ret$0);
  this.l1h_1 = atomic$ref$1(Active_instance);
  this.m1h_1 = atomic$ref$1(null);
}
protoOf(CancellableContinuationImpl).o1i = function () {
  return this.i1h_1;
};
protoOf(CancellableContinuationImpl).z7 = function () {
  return this.j1h_1;
};
protoOf(CancellableContinuationImpl).o1f = function () {
  return this.l1h_1.kotlinx$atomicfu$value;
};
protoOf(CancellableContinuationImpl).p1f = function () {
  var tmp = this.o1f();
  return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
};
protoOf(CancellableContinuationImpl).p1i = function () {
  var tmp0_elvis_lhs = installParentHandle(this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var handle = tmp;
  if (this.p1f()) {
    handle.q1i();
    this.m1h_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  }
};
protoOf(CancellableContinuationImpl).v1h = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var state = this.l1h_1.kotlinx$atomicfu$value;
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp;
  if (state instanceof CompletedContinuation) {
    tmp = !(state.h1i_1 == null);
  } else {
    tmp = false;
  }
  if (tmp) {
    this.n1i();
    return false;
  }
  var tmp_0 = this.k1h_1;
  // Inline function 'kotlinx.coroutines.decisionAndIndex' call
  tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
  this.l1h_1.kotlinx$atomicfu$value = Active_instance;
  return true;
};
protoOf(CancellableContinuationImpl).r1i = function () {
  return this.o1f();
};
protoOf(CancellableContinuationImpl).s1i = function (takenState, cause) {
  var this_0 = this.l1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>' call
    var state = this_0.kotlinx$atomicfu$value;
    if (!(state == null) ? isInterface(state, NotCompleted) : false) {
      // Inline function 'kotlin.error' call
      var message = 'Not completed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      if (state instanceof CompletedExceptionally) return Unit_instance;else {
        if (state instanceof CompletedContinuation) {
          // Inline function 'kotlin.check' call
          if (!!state.k1i()) {
            // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>.<anonymous>' call
            var message_0 = 'Must be called at most once';
            throw IllegalStateException_init_$Create$_0(toString_1(message_0));
          }
          var update = state.l1i(VOID, VOID, VOID, VOID, cause);
          if (this.l1h_1.atomicfu$compareAndSet(state, update)) {
            state.t1i(this, cause);
            return Unit_instance;
          }
        } else {
          if (this.l1h_1.atomicfu$compareAndSet(state, new CompletedContinuation(state, VOID, VOID, VOID, cause))) {
            return Unit_instance;
          }
        }
      }
    }
  }
  return Unit_instance;
};
protoOf(CancellableContinuationImpl).u1i = function (cause) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.l1h_1;
  while (true) {
    var tmp1 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancel.<anonymous>' call
      if (!(!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false)) return false;
      var tmp;
      if (isInterface(tmp1, CancelHandler)) {
        tmp = true;
      } else {
        tmp = tmp1 instanceof Segment;
      }
      var update = new CancelledContinuation(this, cause, tmp);
      if (!this.l1h_1.atomicfu$compareAndSet(tmp1, update)) {
        break $l$block;
      }
      if (isInterface(tmp1, CancelHandler)) {
        this.j1i(tmp1, cause);
      } else {
        if (tmp1 instanceof Segment) {
          callSegmentOnCancellation(this, tmp1, cause);
        }
      }
      detachChildIfNonReusable(this);
      dispatchResume(this, this.x1h_1);
      return true;
    }
  }
};
protoOf(CancellableContinuationImpl).v1i = function (cause) {
  if (cancelLater(this, cause)) return Unit_instance;
  this.u1i(cause);
  detachChildIfNonReusable(this);
};
protoOf(CancellableContinuationImpl).j1i = function (handler, cause) {
  var tmp;
  try {
    handler.w1i(cause);
    tmp = Unit_instance;
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException(this.z7(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
      tmp_0 = Unit_instance;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).x1i = function (onCancellation, cause, value) {
  try {
    onCancellation(cause, value, this.z7());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException(this.z7(), new CompletionHandlerException('Exception in resume onCancellation handler for ' + this.toString(), ex));
    } else {
      throw $p;
    }
  }
};
protoOf(CancellableContinuationImpl).y1i = function (parent) {
  return parent.s1f();
};
protoOf(CancellableContinuationImpl).z1i = function () {
  var isReusable_0 = isReusable(this);
  if (trySuspend(this)) {
    if (_get_parentHandle__f8dcex(this) == null) {
      installParentHandle(this);
    }
    if (isReusable_0) {
      this.a1j();
    }
    return get_COROUTINE_SUSPENDED();
  }
  if (isReusable_0) {
    this.a1j();
  }
  var state = this.o1f();
  if (state instanceof CompletedExceptionally) throw recoverStackTrace(state.a1f_1);
  if (get_isCancellableMode(this.x1h_1)) {
    var job = this.z7().s8(Key_instance_2);
    if (!(job == null) && !job.v1e()) {
      var cause = job.s1f();
      this.s1i(state, cause);
      throw recoverStackTrace(cause);
    }
  }
  return this.b1j(state);
};
protoOf(CancellableContinuationImpl).a1j = function () {
  var tmp = this.i1h_1;
  var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c1j(this);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var cancellationCause = tmp_0;
  this.n1i();
  this.u1i(cancellationCause);
};
protoOf(CancellableContinuationImpl).o8 = function (result) {
  return this.d1j(toState(result), this.x1h_1);
};
protoOf(CancellableContinuationImpl).e1j = function (value, onCancellation) {
  var tmp = this.x1h_1;
  var tmp_0;
  if (onCancellation == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resume.<anonymous>' call
    tmp_0 = CancellableContinuationImpl$resume$lambda(onCancellation);
  }
  return this.f1j(value, tmp, tmp_0);
};
protoOf(CancellableContinuationImpl).g1h = function (value, onCancellation) {
  return this.f1j(value, this.x1h_1, onCancellation);
};
protoOf(CancellableContinuationImpl).g1j = function (segment, index) {
  var tmp0 = this.k1h_1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>' call
      // Inline function 'kotlinx.coroutines.index' call
      // Inline function 'kotlin.check' call
      if (!((cur & 536870911) === 536870911)) {
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>.<anonymous>' call
        var message = 'invokeOnCancellation should be called at most once';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlinx.coroutines.decision' call
      // Inline function 'kotlinx.coroutines.decisionAndIndex' call
      var upd = (cur >> 29 << 29) + index | 0;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        break $l$block;
      }
    }
  }
  invokeOnCancellationImpl(this, segment);
};
protoOf(CancellableContinuationImpl).n1h = function (handler) {
  return invokeOnCancellationImpl(this, handler);
};
protoOf(CancellableContinuationImpl).f1j = function (proposedUpdate, resumeMode, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.l1h_1;
  while (true) {
    var tmp1 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resumeImpl.<anonymous>' call
      if (!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false) {
        var update = resumedState(this, tmp1, proposedUpdate, resumeMode, onCancellation, null);
        if (!this.l1h_1.atomicfu$compareAndSet(tmp1, update)) {
          break $l$block;
        }
        detachChildIfNonReusable(this);
        dispatchResume(this, resumeMode);
        return Unit_instance;
      } else {
        if (tmp1 instanceof CancelledContinuation) {
          if (tmp1.k1j()) {
            if (onCancellation == null) ;else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resumeImpl.<anonymous>.<anonymous>' call
              this.x1i(onCancellation, tmp1.a1f_1, proposedUpdate);
            }
            return Unit_instance;
          }
        }
      }
      alreadyResumedError(this, proposedUpdate);
    }
  }
};
protoOf(CancellableContinuationImpl).d1j = function (proposedUpdate, resumeMode, onCancellation, $super) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  var tmp;
  if ($super === VOID) {
    this.f1j(proposedUpdate, resumeMode, onCancellation);
    tmp = Unit_instance;
  } else {
    tmp = $super.f1j.call(this, proposedUpdate, resumeMode, onCancellation);
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).n1i = function () {
  var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var handle = tmp;
  handle.q1i();
  this.m1h_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
};
protoOf(CancellableContinuationImpl).d1h = function (value, idempotent, onCancellation) {
  return tryResumeImpl(this, value, idempotent, onCancellation);
};
protoOf(CancellableContinuationImpl).e1h = function (token) {
  // Inline function 'kotlinx.coroutines.assert' call
  dispatchResume(this, this.x1h_1);
};
protoOf(CancellableContinuationImpl).f1h = function (_this__u8e3s4, value) {
  var tmp = this.i1h_1;
  var dc = tmp instanceof DispatchedContinuation ? tmp : null;
  var tmp_0;
  if ((dc == null ? null : dc.p1h_1) === _this__u8e3s4) {
    tmp_0 = 4;
  } else {
    tmp_0 = this.x1h_1;
  }
  this.d1j(value, tmp_0);
};
protoOf(CancellableContinuationImpl).b1j = function (state) {
  var tmp;
  if (state instanceof CompletedContinuation) {
    var tmp_0 = state.e1i_1;
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    tmp = (state == null ? true : !(state == null)) ? state : THROW_CCE();
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).l1j = function (state) {
  var tmp0_safe_receiver = protoOf(DispatchedTask).l1j.call(this, state);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.getExceptionalResult.<anonymous>' call
    tmp = recoverStackTrace(tmp0_safe_receiver, this.i1h_1);
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).toString = function () {
  return this.m1j() + '(' + toDebugString(this.i1h_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
};
protoOf(CancellableContinuationImpl).m1j = function () {
  return 'CancellableContinuation';
};
function NotCompleted() {}
function CancelHandler() {}
function Active() {}
protoOf(Active).toString = function () {
  return 'Active';
};
var Active_instance;
function CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
  cancelHandler = cancelHandler === VOID ? null : cancelHandler;
  onCancellation = onCancellation === VOID ? null : onCancellation;
  idempotentResume = idempotentResume === VOID ? null : idempotentResume;
  cancelCause = cancelCause === VOID ? null : cancelCause;
  this.e1i_1 = result;
  this.f1i_1 = cancelHandler;
  this.g1i_1 = onCancellation;
  this.h1i_1 = idempotentResume;
  this.i1i_1 = cancelCause;
}
protoOf(CompletedContinuation).k1i = function () {
  return !(this.i1i_1 == null);
};
protoOf(CompletedContinuation).t1i = function (cont, cause) {
  var tmp0_safe_receiver = this.f1i_1;
  if (tmp0_safe_receiver == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.CompletedContinuation.invokeHandlers.<anonymous>' call
    cont.j1i(tmp0_safe_receiver, cause);
  }
  var tmp1_safe_receiver = this.g1i_1;
  if (tmp1_safe_receiver == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.CompletedContinuation.invokeHandlers.<anonymous>' call
    cont.x1i(tmp1_safe_receiver, cause, this.e1i_1);
  }
};
protoOf(CompletedContinuation).p1j = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
  return new CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
};
protoOf(CompletedContinuation).l1i = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
  result = result === VOID ? this.e1i_1 : result;
  cancelHandler = cancelHandler === VOID ? this.f1i_1 : cancelHandler;
  onCancellation = onCancellation === VOID ? this.g1i_1 : onCancellation;
  idempotentResume = idempotentResume === VOID ? this.h1i_1 : idempotentResume;
  cancelCause = cancelCause === VOID ? this.i1i_1 : cancelCause;
  return $super === VOID ? this.p1j(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.p1j.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
};
protoOf(CompletedContinuation).toString = function () {
  return 'CompletedContinuation(result=' + toString_0(this.e1i_1) + ', cancelHandler=' + toString_0(this.f1i_1) + ', onCancellation=' + toString_0(this.g1i_1) + ', idempotentResume=' + toString_0(this.h1i_1) + ', cancelCause=' + toString_0(this.i1i_1) + ')';
};
protoOf(CompletedContinuation).hashCode = function () {
  var result = this.e1i_1 == null ? 0 : hashCode(this.e1i_1);
  result = imul(result, 31) + (this.f1i_1 == null ? 0 : hashCode(this.f1i_1)) | 0;
  result = imul(result, 31) + (this.g1i_1 == null ? 0 : hashCode(this.g1i_1)) | 0;
  result = imul(result, 31) + (this.h1i_1 == null ? 0 : hashCode(this.h1i_1)) | 0;
  result = imul(result, 31) + (this.i1i_1 == null ? 0 : hashCode(this.i1i_1)) | 0;
  return result;
};
protoOf(CompletedContinuation).equals = function (other) {
  if (this === other) return true;
  if (!(other instanceof CompletedContinuation)) return false;
  var tmp0_other_with_cast = other instanceof CompletedContinuation ? other : THROW_CCE();
  if (!equals(this.e1i_1, tmp0_other_with_cast.e1i_1)) return false;
  if (!equals(this.f1i_1, tmp0_other_with_cast.f1i_1)) return false;
  if (!equals(this.g1i_1, tmp0_other_with_cast.g1i_1)) return false;
  if (!equals(this.h1i_1, tmp0_other_with_cast.h1i_1)) return false;
  if (!equals(this.i1i_1, tmp0_other_with_cast.i1i_1)) return false;
  return true;
};
function ChildContinuation(child) {
  JobNode.call(this);
  this.u1j_1 = child;
}
protoOf(ChildContinuation).v1j = function () {
  return true;
};
protoOf(ChildContinuation).w1i = function (cause) {
  this.u1j_1.v1i(this.u1j_1.y1i(this.a1k()));
};
var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
  if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
    properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
    RESUME_TOKEN = new _Symbol('RESUME_TOKEN');
  }
}
function CompletedExceptionally(cause, handled) {
  handled = handled === VOID ? false : handled;
  this.a1f_1 = cause;
  this.b1f_1 = atomic$boolean$1(handled);
}
protoOf(CompletedExceptionally).c1f = function () {
  return this.b1f_1.kotlinx$atomicfu$value;
};
protoOf(CompletedExceptionally).m1i = function () {
  return this.b1f_1.atomicfu$compareAndSet(false, true);
};
protoOf(CompletedExceptionally).toString = function () {
  return get_classSimpleName(this) + '[' + this.a1f_1.toString() + ']';
};
function CancelledContinuation(continuation, cause, handled) {
  CompletedExceptionally.call(this, cause == null ? CancellationException_init_$Create$_0('Continuation ' + toString_1(continuation) + ' was cancelled normally') : cause, handled);
  this.j1j_1 = atomic$boolean$1(false);
}
protoOf(CancelledContinuation).k1j = function () {
  return this.j1j_1.atomicfu$compareAndSet(false, true);
};
function toState(_this__u8e3s4, caller) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
    tmp = new CompletedExceptionally(recoverStackTrace(exception));
  }
  return tmp;
}
function toState_0(_this__u8e3s4) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
    tmp = new CompletedExceptionally(exception);
  }
  return tmp;
}
function recoverResult(state, uCont) {
  var tmp;
  if (state instanceof CompletedExceptionally) {
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(state.a1f_1);
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = (state == null ? true : !(state == null)) ? state : THROW_CCE();
    tmp = _Result___init__impl__xyqfz8(value);
  }
  return tmp;
}
function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
  return it instanceof CoroutineDispatcher ? it : null;
}
function Key() {
  Key_instance_0 = this;
  var tmp = Key_instance;
  AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
}
var Key_instance_0;
function Key_getInstance() {
  if (Key_instance_0 == null) new Key();
  return Key_instance_0;
}
function CoroutineDispatcher() {
  Key_getInstance();
  AbstractCoroutineContextElement.call(this, Key_instance);
}
protoOf(CoroutineDispatcher).j1k = function (context) {
  return true;
};
protoOf(CoroutineDispatcher).t8 = function (continuation) {
  return new DispatchedContinuation(this, continuation);
};
protoOf(CoroutineDispatcher).u8 = function (continuation) {
  var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
  dispatched.l1k();
};
protoOf(CoroutineDispatcher).toString = function () {
  return get_classSimpleName(this) + '@' + get_hexAddress(this);
};
function handleCoroutineException(context, exception) {
  var tmp;
  if (exception instanceof DispatchException) {
    tmp = exception.m1k_1;
  } else {
    tmp = exception;
  }
  var reportException = tmp;
  try {
    var tmp0_safe_receiver = context.s8(Key_instance_1);
    if (tmp0_safe_receiver == null) null;else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.n1k(context, reportException);
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      handleUncaughtCoroutineException(context, handlerException(reportException, t));
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  handleUncaughtCoroutineException(context, reportException);
}
function Key_0() {}
var Key_instance_1;
function handlerException(originalException, thrownException) {
  if (originalException === thrownException) return originalException;
  // Inline function 'kotlin.apply' call
  var this_0 = RuntimeException_init_$Create$_1('Exception while trying to handle coroutine exception', thrownException);
  // Inline function 'kotlinx.coroutines.handlerException.<anonymous>' call
  addSuppressed(this_0, originalException);
  return this_0;
}
function CoroutineScope() {}
function CoroutineScope_0(context) {
  return new ContextScope(!(context.s8(Key_instance_2) == null) ? context : context.ld(Job()));
}
var CoroutineStart_DEFAULT_instance;
var CoroutineStart_LAZY_instance;
var CoroutineStart_entriesInitialized;
function CoroutineStart_initEntries() {
  if (CoroutineStart_entriesInitialized) return Unit_instance;
  CoroutineStart_entriesInitialized = true;
  CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
  CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
  new CoroutineStart('ATOMIC', 2);
  new CoroutineStart('UNDISPATCHED', 3);
}
function CoroutineStart(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(CoroutineStart).l1f = function (block, receiver, completion) {
  var tmp;
  switch (this.c2_1) {
    case 0:
      startCoroutineCancellable_0(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 2:
      startCoroutine(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 3:
      startCoroutineUndispatched(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 1:
      tmp = Unit_instance;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CoroutineStart).n1g = function () {
  return this === CoroutineStart_LAZY_getInstance();
};
function CoroutineStart_DEFAULT_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_DEFAULT_instance;
}
function CoroutineStart_LAZY_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_LAZY_instance;
}
function Delay() {}
function get_delay(_this__u8e3s4) {
  var tmp = _this__u8e3s4.s8(Key_instance);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
}
function delay(duration, $completion) {
  return delay_0(toDelayMillis(duration), $completion);
}
function DelayWithTimeoutDiagnostics() {}
function delay_0(timeMillis, $completion) {
  if (timeMillis.z(new Long(0, 0)) <= 0) return Unit_instance;
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.p1i();
  // Inline function 'kotlinx.coroutines.delay.<anonymous>' call
  if (timeMillis.z(new Long(-1, 2147483647)) < 0) {
    get_delay(cancellable.z7()).o1k(timeMillis, cancellable);
  }
  return cancellable.z1i();
}
function toDelayMillis(_this__u8e3s4) {
  var tmp;
  switch (Duration__isPositive_impl_tvkkt2(_this__u8e3s4)) {
    case true:
      Companion_getInstance_16();
      // Inline function 'kotlin.time.Companion.nanoseconds' call

      var this_0 = new Long(999999, 0);
      var tmp$ret$0 = toDuration_0(this_0, DurationUnit_NANOSECONDS_getInstance());
      tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(Duration__plus_impl_yu9v8f(_this__u8e3s4, tmp$ret$0));
      break;
    case false:
      tmp = new Long(0, 0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function delta($this, unconfined) {
  return unconfined ? new Long(0, 1) : new Long(1, 0);
}
function EventLoop() {
  CoroutineDispatcher.call(this);
  this.s1k_1 = new Long(0, 0);
  this.t1k_1 = false;
  this.u1k_1 = null;
}
protoOf(EventLoop).v1k = function () {
  var tmp0_elvis_lhs = this.u1k_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var queue = tmp;
  var tmp1_elvis_lhs = queue.gc();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var task = tmp_0;
  task.n1j();
  return true;
};
protoOf(EventLoop).w1k = function (task) {
  var tmp0_elvis_lhs = this.u1k_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayDeque_init_$Create$();
    // Inline function 'kotlinx.coroutines.EventLoop.dispatchUnconfined.<anonymous>' call
    this.u1k_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var queue = tmp;
  queue.ec(task);
};
protoOf(EventLoop).x1k = function () {
  return this.s1k_1.z(delta(this, true)) >= 0;
};
protoOf(EventLoop).y1k = function () {
  var tmp0_safe_receiver = this.u1k_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n();
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
};
protoOf(EventLoop).z1k = function (unconfined) {
  this.s1k_1 = this.s1k_1.i2(delta(this, unconfined));
  if (!unconfined) this.t1k_1 = true;
};
protoOf(EventLoop).a1l = function (unconfined) {
  this.s1k_1 = this.s1k_1.j2(delta(this, unconfined));
  if (this.s1k_1.z(new Long(0, 0)) > 0) return Unit_instance;
  // Inline function 'kotlinx.coroutines.assert' call
  if (this.t1k_1) {
    this.b1l();
  }
};
protoOf(EventLoop).b1l = function () {};
function ThreadLocalEventLoop() {
  ThreadLocalEventLoop_instance = this;
  this.c1l_1 = commonThreadLocal();
}
protoOf(ThreadLocalEventLoop).d1l = function () {
  var tmp0_elvis_lhs = this.c1l_1.f1l();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = createEventLoop();
    // Inline function 'kotlinx.coroutines.ThreadLocalEventLoop.<get-eventLoop>.<anonymous>' call
    ThreadLocalEventLoop_getInstance().c1l_1.g1l(this_0);
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance == null) new ThreadLocalEventLoop();
  return ThreadLocalEventLoop_instance;
}
function CompletionHandlerException(message, cause) {
  RuntimeException_init_$Init$_1(message, cause, this);
  captureStack(this, CompletionHandlerException);
}
function CoroutinesInternalError(message, cause) {
  Error_init_$Init$_1(message, cause, this);
  captureStack(this, CoroutinesInternalError);
}
function Key_1() {}
var Key_instance_2;
function ParentJob() {}
function NonDisposableHandle() {}
protoOf(NonDisposableHandle).q1i = function () {};
protoOf(NonDisposableHandle).b1g = function (cause) {
  return false;
};
protoOf(NonDisposableHandle).toString = function () {
  return 'NonDisposableHandle';
};
var NonDisposableHandle_instance;
function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  var tmp;
  if (_this__u8e3s4 instanceof JobSupport) {
    tmp = _this__u8e3s4.x1f(invokeImmediately, handler);
  } else {
    var tmp_0 = handler.v1j();
    tmp = _this__u8e3s4.w1f(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
  }
  return tmp;
}
function Job(parent) {
  parent = parent === VOID ? null : parent;
  return new JobImpl(parent);
}
function disposeOnCompletion(_this__u8e3s4, handle) {
  return invokeOnCompletion(_this__u8e3s4, VOID, new DisposeOnCompletion(handle));
}
function DisposeOnCompletion(handle) {
  JobNode.call(this);
  this.l1l_1 = handle;
}
protoOf(DisposeOnCompletion).v1j = function () {
  return false;
};
protoOf(DisposeOnCompletion).w1i = function (cause) {
  return this.l1l_1.q1i();
};
function JobNode$invoke$ref($boundThis) {
  var l = function l(p0) {
    $boundThis.w1i(p0);
    return Unit_instance;
  };
  l.callableName = 'invoke';
  return l;
}
function get_COMPLETING_ALREADY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_ALREADY;
}
var COMPLETING_ALREADY;
function get_COMPLETING_WAITING_CHILDREN() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_WAITING_CHILDREN;
}
var COMPLETING_WAITING_CHILDREN;
function get_COMPLETING_RETRY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_RETRY;
}
var COMPLETING_RETRY;
function get_TOO_LATE_TO_CANCEL() {
  _init_properties_JobSupport_kt__68f172();
  return TOO_LATE_TO_CANCEL;
}
var TOO_LATE_TO_CANCEL;
function get_SEALED() {
  _init_properties_JobSupport_kt__68f172();
  return SEALED;
}
var SEALED;
function get_EMPTY_NEW() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_NEW;
}
var EMPTY_NEW;
function get_EMPTY_ACTIVE() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_ACTIVE;
}
var EMPTY_ACTIVE;
function Empty(isActive) {
  this.m1l_1 = isActive;
}
protoOf(Empty).v1e = function () {
  return this.m1l_1;
};
protoOf(Empty).b1k = function () {
  return null;
};
protoOf(Empty).toString = function () {
  return 'Empty{' + (this.m1l_1 ? 'Active' : 'New') + '}';
};
function Incomplete() {}
function NodeList() {
  LockFreeLinkedListHead.call(this);
}
protoOf(NodeList).v1e = function () {
  return true;
};
protoOf(NodeList).b1k = function () {
  return this;
};
protoOf(NodeList).q1l = function (state) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$_0();
  // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>' call
  this_0.h7('List{');
  this_0.h7(state);
  this_0.h7('}[');
  var first = true;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = this.c1k_1;
  while (!equals(cur, this)) {
    // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>.<anonymous>' call
    var node = cur;
    if (node instanceof JobNode) {
      if (first) {
        first = false;
      } else this_0.h7(', ');
      this_0.g7(node);
    }
    cur = cur.c1k_1;
  }
  this_0.h7(']');
  return this_0.toString();
};
protoOf(NodeList).toString = function () {
  return get_DEBUG() ? this.q1l('Active') : protoOf(LockFreeLinkedListHead).toString.call(this);
};
function JobNode() {
  LockFreeLinkedListNode.call(this);
}
protoOf(JobNode).a1k = function () {
  var tmp = this.z1j_1;
  if (!(tmp == null)) return tmp;else {
    throwUninitializedPropertyAccessException('job');
  }
};
protoOf(JobNode).v1e = function () {
  return true;
};
protoOf(JobNode).b1k = function () {
  return null;
};
protoOf(JobNode).q1i = function () {
  return this.a1k().y1f(this);
};
protoOf(JobNode).toString = function () {
  return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.a1k()) + ']';
};
function _set_exceptionsHolder__tqm22h($this, value) {
  $this.v1l_1.kotlinx$atomicfu$value = value;
}
function _get_exceptionsHolder__nhszp($this) {
  return $this.v1l_1.kotlinx$atomicfu$value;
}
function allocateList($this) {
  return ArrayList_init_$Create$_0(4);
}
function finalizeFinishingState($this, state, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1f_1;
  var wasCancelling;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  // Inline function 'kotlinx.coroutines.JobSupport.finalizeFinishingState.<anonymous>' call
  wasCancelling = state.w1l();
  var exceptions = state.x1l(proposedException);
  var finalCause = getFinalRootCause($this, state, exceptions);
  if (!(finalCause == null)) {
    addSuppressedExceptions($this, finalCause, exceptions);
  }
  var finalException = finalCause;
  var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
  if (!(finalException == null)) {
    var handled = cancelParent($this, finalException) || $this.j1g(finalException);
    if (handled) {
      (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).m1i();
    }
  }
  if (!wasCancelling) {
    $this.g1g(finalException);
  }
  $this.z1e(finalState);
  $this.o1e_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
  // Inline function 'kotlinx.coroutines.assert' call
  completeStateFinalization($this, state, finalState);
  return finalState;
}
function getFinalRootCause($this, state, exceptions) {
  if (exceptions.n()) {
    if (state.w1l()) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      return new JobCancellationException($this.y1e() , null, $this);
    }
    return null;
  }
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = exceptions.i();
    while (_iterator__ex2g4s.j()) {
      var element = _iterator__ex2g4s.k();
      // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
      if (!(element instanceof CancellationException)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var firstNonCancellation = tmp$ret$2;
  if (!(firstNonCancellation == null)) return firstNonCancellation;
  var first = exceptions.m(0);
  if (first instanceof TimeoutCancellationException) {
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = exceptions.i();
      while (_iterator__ex2g4s_0.j()) {
        var element_0 = _iterator__ex2g4s_0.k();
        // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
        var tmp;
        if (!(element_0 === first)) {
          tmp = element_0 instanceof TimeoutCancellationException;
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$4 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    var detailedTimeoutException = tmp$ret$4;
    if (!(detailedTimeoutException == null)) return detailedTimeoutException;
  }
  return first;
}
function addSuppressedExceptions($this, rootCause, exceptions) {
  if (exceptions.l() <= 1) return Unit_instance;
  var seenExceptions = identitySet(exceptions.l());
  var unwrappedCause = unwrap(rootCause);
  var _iterator__ex2g4s = exceptions.i();
  while (_iterator__ex2g4s.j()) {
    var exception = _iterator__ex2g4s.k();
    var unwrapped = unwrap(exception);
    var tmp;
    var tmp_0;
    if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
      tmp_0 = !(unwrapped instanceof CancellationException);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = seenExceptions.d(unwrapped);
    } else {
      tmp = false;
    }
    if (tmp) {
      addSuppressed(rootCause, unwrapped);
    }
  }
}
function tryFinalizeSimpleState($this, state, update) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  if (!$this.o1e_1.atomicfu$compareAndSet(state, boxIncomplete(update))) return false;
  $this.g1g(null);
  $this.z1e(update);
  completeStateFinalization($this, state, update);
  return true;
}
function completeStateFinalization($this, state, update) {
  var tmp0_safe_receiver = $this.n1f();
  if (tmp0_safe_receiver == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.JobSupport.completeStateFinalization.<anonymous>' call
    tmp0_safe_receiver.q1i();
    $this.m1f(NonDisposableHandle_instance);
  }
  var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
  var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a1f_1;
  if (state instanceof JobNode) {
    try {
      state.w1i(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        $this.g1f(new CompletionHandlerException('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  } else {
    var tmp2_safe_receiver = state.b1k();
    if (tmp2_safe_receiver == null) ;else {
      notifyCompletion(tmp2_safe_receiver, $this, cause);
    }
  }
}
function notifyCancelling($this, list, cause) {
  $this.g1g(cause);
  list.r1l(4);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = list.c1k_1;
  while (!equals(cur, list)) {
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      // Inline function 'kotlinx.coroutines.JobSupport.notifyCancelling.<anonymous>' call
      tmp = node.v1j();
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.w1i(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
            exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.c1k_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
    $this.g1f(tmp0_safe_receiver_0);
  }
  cancelParent($this, cause);
}
function cancelParent($this, cause) {
  if ($this.h1g()) return true;
  var isCancellation = cause instanceof CancellationException;
  var parent = $this.n1f();
  if (parent === null || parent === NonDisposableHandle_instance) {
    return isCancellation;
  }
  return parent.b1g(cause) || isCancellation;
}
function notifyCompletion(_this__u8e3s4, $this, cause) {
  _this__u8e3s4.r1l(1);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = _this__u8e3s4.c1k_1;
  while (!equals(cur, _this__u8e3s4)) {
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      // Inline function 'kotlinx.coroutines.JobSupport.notifyCompletion.<anonymous>' call
      tmp = true;
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.w1i(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
            exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.c1k_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
    $this.g1f(tmp0_safe_receiver_0);
  }
}
function startInternal($this, state) {
  if (state instanceof Empty) {
    if (state.m1l_1) return 0;
    if (!$this.o1e_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE())) return -1;
    $this.r1f();
    return 1;
  } else {
    if (state instanceof InactiveNodeList) {
      if (!$this.o1e_1.atomicfu$compareAndSet(state, state.y1l_1)) return -1;
      $this.r1f();
      return 1;
    } else {
      return 0;
    }
  }
}
function promoteEmptyToNodeList($this, state) {
  var list = new NodeList();
  var update = state.m1l_1 ? list : new InactiveNodeList(list);
  $this.o1e_1.atomicfu$compareAndSet(state, update);
}
function promoteSingleToNodeList($this, state) {
  state.h1k(new NodeList());
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
  var list = state.c1k_1;
  $this.o1e_1.atomicfu$compareAndSet(state, list);
}
function cancelMakeCompleting($this, cause) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    // Inline function 'kotlinx.coroutines.JobSupport.cancelMakeCompleting.<anonymous>' call
    var state = $this.o1f();
    var tmp;
    if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.z1l();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      return get_COMPLETING_ALREADY();
    }
    var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
    var finalState = tryMakeCompleting($this, state, proposedUpdate);
    if (!(finalState === get_COMPLETING_RETRY())) return finalState;
  }
}
function createCauseException($this, cause) {
  var tmp;
  if (cause == null ? true : cause instanceof Error) {
    var tmp_0;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp_0 = new JobCancellationException($this.y1e() , null, $this);
    } else {
      tmp_0 = cause;
    }
    tmp = tmp_0;
  } else {
    tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).e1g();
  }
  return tmp;
}
function makeCancelling($this, cause) {
  var causeExceptionCache = null;
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp1 = $this.o1f();
    $l$block: {
      // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>' call
      if (tmp1 instanceof Finishing) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
        if (tmp1.a1m()) return get_TOO_LATE_TO_CANCEL();
        var wasCancelling = tmp1.w1l();
        if (!(cause == null) || !wasCancelling) {
          var tmp0_elvis_lhs = causeExceptionCache;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createCauseException($this, cause);
            // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
            causeExceptionCache = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var causeException = tmp;
          tmp1.b1m(causeException);
        }
        // Inline function 'kotlin.takeIf' call
        var this_1 = tmp1.c1m();
        var tmp_0;
        // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
        if (!wasCancelling) {
          tmp_0 = this_1;
        } else {
          tmp_0 = null;
        }
        var notifyRootCause = tmp_0;
        if (notifyRootCause == null) ;else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
          notifyCancelling($this, tmp1.s1l_1, notifyRootCause);
        }
        return get_COMPLETING_ALREADY();
      } else {
        if (!(tmp1 == null) ? isInterface(tmp1, Incomplete) : false) {
          var tmp2_elvis_lhs = causeExceptionCache;
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = createCauseException($this, cause);
            // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
            causeExceptionCache = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var causeException_0 = tmp_1;
          if (tmp1.v1e()) {
            if (tryMakeCancelling($this, tmp1, causeException_0)) return get_COMPLETING_ALREADY();
          } else {
            var finalState = tryMakeCompleting($this, tmp1, new CompletedExceptionally(causeException_0));
            if (finalState === get_COMPLETING_ALREADY()) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot happen in ' + toString_1(tmp1);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else return finalState;
          }
        } else {
          return get_TOO_LATE_TO_CANCEL();
        }
      }
    }
  }
}
function getOrPromoteCancellingList($this, state) {
  var tmp0_elvis_lhs = state.b1k();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (state instanceof Empty) {
      tmp_0 = new NodeList();
    } else {
      if (state instanceof JobNode) {
        promoteSingleToNodeList($this, state);
        tmp_0 = null;
      } else {
        var message = 'State should have list: ' + toString_1(state);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function tryMakeCancelling($this, state, rootCause) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var cancelling = new Finishing(list, false, rootCause);
  if (!$this.o1e_1.atomicfu$compareAndSet(state, cancelling)) return false;
  notifyCancelling($this, list, rootCause);
  return true;
}
function tryMakeCompleting($this, state, proposedUpdate) {
  if (!(!(state == null) ? isInterface(state, Incomplete) : false)) return get_COMPLETING_ALREADY();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (state instanceof Empty) {
    tmp_1 = true;
  } else {
    tmp_1 = state instanceof JobNode;
  }
  if (tmp_1) {
    tmp_0 = !(state instanceof ChildHandleNode);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = !(proposedUpdate instanceof CompletedExceptionally);
  } else {
    tmp = false;
  }
  if (tmp) {
    if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
      return proposedUpdate;
    }
    return get_COMPLETING_RETRY();
  }
  return tryMakeCompletingSlowPath($this, state, proposedUpdate);
}
function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return get_COMPLETING_RETRY();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
  var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
  var notifyRootCause;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (finishing.z1l()) return get_COMPLETING_ALREADY();
  finishing.d1m(true);
  if (!(finishing === state)) {
    if (!$this.o1e_1.atomicfu$compareAndSet(state, finishing)) return get_COMPLETING_RETRY();
  }
  // Inline function 'kotlinx.coroutines.assert' call
  var wasCancelling = finishing.w1l();
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  if (tmp0_safe_receiver == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>.<anonymous>' call
    finishing.b1m(tmp0_safe_receiver.a1f_1);
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = finishing.c1m();
  var tmp_0;
  // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>.<anonymous>' call
  if (!wasCancelling) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  notifyRootCause = tmp_0;
  if (notifyRootCause == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>' call
    notifyCancelling($this, list, notifyRootCause);
  }
  var child = nextChild(list);
  if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate)) return get_COMPLETING_WAITING_CHILDREN();
  list.r1l(2);
  var anotherChild = nextChild(list);
  if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate)) return get_COMPLETING_WAITING_CHILDREN();
  return finalizeFinishingState($this, finishing, proposedUpdate);
}
function _get_exceptionOrNull__b3j7js(_this__u8e3s4, $this) {
  var tmp0_safe_receiver = _this__u8e3s4 instanceof CompletedExceptionally ? _this__u8e3s4 : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1f_1;
}
function tryWaitForChild($this, state, child, proposedUpdate) {
  var $this_0 = $this;
  var state_0 = state;
  var child_0 = child;
  var proposedUpdate_0 = proposedUpdate;
  do {
    $l$0: do {
      var handle = invokeOnCompletion(child_0.i1m_1, false, new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0));
      if (!(handle === NonDisposableHandle_instance)) return true;
      var tmp0_elvis_lhs = nextChild(child_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      var tmp0 = $this_0;
      var tmp1 = state_0;
      var tmp3 = proposedUpdate_0;
      $this_0 = tmp0;
      state_0 = tmp1;
      child_0 = nextChild_0;
      proposedUpdate_0 = tmp3;
      continue $l$0;
    } while (false);
  } while (true);
}
function continueCompleting($this, state, lastChild, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  var waitChild = nextChild(lastChild);
  if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate)) return Unit_instance;
  state.s1l_1.r1l(2);
  var waitChildAgain = nextChild(lastChild);
  if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
    return Unit_instance;
  }
  var finalState = finalizeFinishingState($this, state, proposedUpdate);
  $this.f1f(finalState);
}
function nextChild(_this__u8e3s4, $this) {
  var cur = _this__u8e3s4;
  $l$loop: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (!cur.e1k_1) {
      break $l$loop;
    }
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
    cur = cur.d1k_1;
  }
  $l$loop_0: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    cur = cur.c1k_1;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (cur.e1k_1) continue $l$loop_0;
    if (cur instanceof ChildHandleNode) return cur;
    if (cur instanceof NodeList) return null;
  }
}
function stateString($this, state) {
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.w1l() ? 'Cancelling' : state.z1l() ? 'Completing' : 'Active';
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.v1e() ? 'Active' : 'New';
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
  }
  return tmp;
}
function Finishing(list, isCompleting, rootCause) {
  SynchronizedObject.call(this);
  this.s1l_1 = list;
  this.t1l_1 = atomic$boolean$1(isCompleting);
  this.u1l_1 = atomic$ref$1(rootCause);
  this.v1l_1 = atomic$ref$1(null);
}
protoOf(Finishing).b1k = function () {
  return this.s1l_1;
};
protoOf(Finishing).d1m = function (value) {
  this.t1l_1.kotlinx$atomicfu$value = value;
};
protoOf(Finishing).z1l = function () {
  return this.t1l_1.kotlinx$atomicfu$value;
};
protoOf(Finishing).j1m = function (value) {
  this.u1l_1.kotlinx$atomicfu$value = value;
};
protoOf(Finishing).c1m = function () {
  return this.u1l_1.kotlinx$atomicfu$value;
};
protoOf(Finishing).a1m = function () {
  return _get_exceptionsHolder__nhszp(this) === get_SEALED();
};
protoOf(Finishing).w1l = function () {
  return !(this.c1m() == null);
};
protoOf(Finishing).v1e = function () {
  return this.c1m() == null;
};
protoOf(Finishing).x1l = function (proposedException) {
  var eh = _get_exceptionsHolder__nhszp(this);
  var tmp;
  if (eh == null) {
    tmp = allocateList();
  } else {
    if (eh instanceof Error) {
      // Inline function 'kotlin.also' call
      var this_0 = allocateList();
      // Inline function 'kotlinx.coroutines.Finishing.sealLocked.<anonymous>' call
      this_0.d(eh);
      tmp = this_0;
    } else {
      if (eh instanceof ArrayList) {
        tmp = eh instanceof ArrayList ? eh : THROW_CCE();
      } else {
        var message = 'State is ' + toString_0(eh);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  var list = tmp;
  var rootCause = this.c1m();
  if (rootCause == null) ;else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.Finishing.sealLocked.<anonymous>' call
    list.w3(0, rootCause);
  }
  if (!(proposedException == null) && !equals(proposedException, rootCause)) {
    list.d(proposedException);
  }
  _set_exceptionsHolder__tqm22h(this, get_SEALED());
  return list;
};
protoOf(Finishing).b1m = function (exception) {
  var rootCause = this.c1m();
  if (rootCause == null) {
    this.j1m(exception);
    return Unit_instance;
  }
  if (exception === rootCause) return Unit_instance;
  var eh = _get_exceptionsHolder__nhszp(this);
  if (eh == null) {
    _set_exceptionsHolder__tqm22h(this, exception);
  } else {
    if (eh instanceof Error) {
      if (exception === eh) return Unit_instance;
      // Inline function 'kotlin.apply' call
      var this_0 = allocateList();
      // Inline function 'kotlinx.coroutines.Finishing.addExceptionLocked.<anonymous>' call
      this_0.d(eh);
      this_0.d(exception);
      _set_exceptionsHolder__tqm22h(this, this_0);
    } else {
      if (eh instanceof ArrayList) {
        (eh instanceof ArrayList ? eh : THROW_CCE()).d(exception);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'State is ' + toString_0(eh);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
};
protoOf(Finishing).toString = function () {
  return 'Finishing[cancelling=' + this.w1l() + ', completing=' + this.z1l() + ', rootCause=' + toString_0(this.c1m()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.s1l_1.toString() + ']';
};
function ChildCompletion(parent, state, child, proposedUpdate) {
  JobNode.call(this);
  this.o1m_1 = parent;
  this.p1m_1 = state;
  this.q1m_1 = child;
  this.r1m_1 = proposedUpdate;
}
protoOf(ChildCompletion).v1j = function () {
  return false;
};
protoOf(ChildCompletion).w1i = function (cause) {
  continueCompleting(this.o1m_1, this.p1m_1, this.q1m_1, this.r1m_1);
};
function JobSupport(active) {
  this.o1e_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
  this.p1e_1 = atomic$ref$1(null);
}
protoOf(JobSupport).r1 = function () {
  return Key_instance_2;
};
protoOf(JobSupport).m1f = function (value) {
  this.p1e_1.kotlinx$atomicfu$value = value;
};
protoOf(JobSupport).n1f = function () {
  return this.p1e_1.kotlinx$atomicfu$value;
};
protoOf(JobSupport).q1e = function (parent) {
  // Inline function 'kotlinx.coroutines.assert' call
  if (parent == null) {
    this.m1f(NonDisposableHandle_instance);
    return Unit_instance;
  }
  parent.q1f();
  var handle = parent.f1g(this);
  this.m1f(handle);
  if (this.p1f()) {
    handle.q1i();
    this.m1f(NonDisposableHandle_instance);
  }
};
protoOf(JobSupport).o1f = function () {
  return this.o1e_1.kotlinx$atomicfu$value;
};
protoOf(JobSupport).v1e = function () {
  var state = this.o1f();
  var tmp;
  if (!(state == null) ? isInterface(state, Incomplete) : false) {
    tmp = state.v1e();
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(JobSupport).p1f = function () {
  var tmp = this.o1f();
  return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
};
protoOf(JobSupport).q1f = function () {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    // Inline function 'kotlinx.coroutines.JobSupport.start.<anonymous>' call
    var state = this.o1f();
    var tmp0_subject = startInternal(this, state);
    if (tmp0_subject === 0) return false;else if (tmp0_subject === 1) return true;
  }
};
protoOf(JobSupport).r1f = function () {};
protoOf(JobSupport).s1f = function () {
  var state = this.o1f();
  var tmp;
  if (state instanceof Finishing) {
    var tmp0_safe_receiver = state.c1m();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.t1f(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = 'Job is still new or active: ' + this.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp = tmp_0;
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      var message_0 = 'Job is still new or active: ' + this.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = this.u1f(state.a1f_1);
      } else {
        tmp = new JobCancellationException(get_classSimpleName(this) + ' has completed normally', null, this);
      }
    }
  }
  return tmp;
};
protoOf(JobSupport).t1f = function (_this__u8e3s4, message) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
    tmp = new JobCancellationException(message == null ? this.y1e() : message, _this__u8e3s4, this);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(JobSupport).u1f = function (_this__u8e3s4, message, $super) {
  message = message === VOID ? null : message;
  return $super === VOID ? this.t1f(_this__u8e3s4, message) : $super.t1f.call(this, _this__u8e3s4, message);
};
protoOf(JobSupport).v1f = function (handler) {
  return this.x1f(true, new InvokeOnCompletion(handler));
};
protoOf(JobSupport).w1f = function (onCancelling, invokeImmediately, handler) {
  var tmp;
  if (onCancelling) {
    tmp = new InvokeOnCancelling(handler);
  } else {
    tmp = new InvokeOnCompletion(handler);
  }
  return this.x1f(invokeImmediately, tmp);
};
protoOf(JobSupport).x1f = function (invokeImmediately, node) {
  node.z1j_1 = this;
  var tmp$ret$0;
  $l$block_1: {
    // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList.<anonymous>' call
      var state = this.o1f();
      if (state instanceof Empty) {
        if (state.m1l_1) {
          if (this.o1e_1.atomicfu$compareAndSet(state, node)) {
            tmp$ret$0 = true;
            break $l$block_1;
          }
        } else {
          promoteEmptyToNodeList(this, state);
        }
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var list = state.b1k();
          if (list == null) {
            promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
          } else {
            // Inline function 'kotlinx.coroutines.JobSupport.invokeOnCompletionInternal.<anonymous>' call
            var tmp;
            if (node.v1j()) {
              var tmp0_safe_receiver = state instanceof Finishing ? state : null;
              var rootCause = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c1m();
              var tmp_0;
              if (rootCause == null) {
                tmp_0 = list.f1k(node, 5);
              } else {
                if (invokeImmediately) {
                  node.w1i(rootCause);
                }
                return NonDisposableHandle_instance;
              }
              tmp = tmp_0;
            } else {
              tmp = list.f1k(node, 1);
            }
            if (tmp) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
          }
        } else {
          tmp$ret$0 = false;
          break $l$block_1;
        }
      }
    }
  }
  var added = tmp$ret$0;
  if (added) return node;else if (invokeImmediately) {
    var tmp_1 = this.o1f();
    var tmp0_safe_receiver_0 = tmp_1 instanceof CompletedExceptionally ? tmp_1 : null;
    node.w1i(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.a1f_1);
  }
  return NonDisposableHandle_instance;
};
protoOf(JobSupport).y1f = function (node) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    // Inline function 'kotlinx.coroutines.JobSupport.removeNode.<anonymous>' call
    var state = this.o1f();
    if (state instanceof JobNode) {
      if (!(state === node)) return Unit_instance;
      if (this.o1e_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE())) return Unit_instance;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        if (!(state.b1k() == null)) {
          node.g1k();
        }
        return Unit_instance;
      } else {
        return Unit_instance;
      }
    }
  }
};
protoOf(JobSupport).z1f = function () {
  return false;
};
protoOf(JobSupport).y1e = function () {
  return 'Job was cancelled';
};
protoOf(JobSupport).a1g = function (parentJob) {
  this.d1g(parentJob);
};
protoOf(JobSupport).b1g = function (cause) {
  if (cause instanceof CancellationException) return true;
  return this.d1g(cause) && this.i1g();
};
protoOf(JobSupport).c1g = function (cause) {
  return this.d1g(cause);
};
protoOf(JobSupport).d1g = function (cause) {
  var finalState = get_COMPLETING_ALREADY();
  if (this.z1f()) {
    finalState = cancelMakeCompleting(this, cause);
    if (finalState === get_COMPLETING_WAITING_CHILDREN()) return true;
  }
  if (finalState === get_COMPLETING_ALREADY()) {
    finalState = makeCancelling(this, cause);
  }
  var tmp;
  if (finalState === get_COMPLETING_ALREADY()) {
    tmp = true;
  } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
    tmp = true;
  } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
    tmp = false;
  } else {
    this.f1f(finalState);
    tmp = true;
  }
  return tmp;
};
protoOf(JobSupport).e1g = function () {
  var state = this.o1f();
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.c1m();
  } else {
    if (state instanceof CompletedExceptionally) {
      tmp = state.a1f_1;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var message = 'Cannot be cancelling child in this state: ' + toString_1(state);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp = null;
      }
    }
  }
  var rootCause = tmp;
  var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
  return tmp1_elvis_lhs == null ? new JobCancellationException('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
};
protoOf(JobSupport).d1f = function (proposedUpdate) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp1 = this.o1f();
    $l$block: {
      // Inline function 'kotlinx.coroutines.JobSupport.makeCompletingOnce.<anonymous>' call
      var finalState = tryMakeCompleting(this, tmp1, proposedUpdate);
      if (finalState === get_COMPLETING_ALREADY()) throw IllegalStateException_init_$Create$_1('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(proposedUpdate));else if (finalState === get_COMPLETING_RETRY()) {
        break $l$block;
      } else return finalState;
    }
  }
};
protoOf(JobSupport).f1g = function (child) {
  // Inline function 'kotlin.also' call
  var this_0 = new ChildHandleNode(child);
  // Inline function 'kotlinx.coroutines.JobSupport.attachChild.<anonymous>' call
  this_0.z1j_1 = this;
  var node = this_0;
  var tmp$ret$1;
  $l$block_1: {
    // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList.<anonymous>' call
      var state = this.o1f();
      if (state instanceof Empty) {
        if (state.m1l_1) {
          if (this.o1e_1.atomicfu$compareAndSet(state, node)) {
            tmp$ret$1 = true;
            break $l$block_1;
          }
        } else {
          promoteEmptyToNodeList(this, state);
        }
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var list = state.b1k();
          if (list == null) {
            promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
          } else {
            // Inline function 'kotlinx.coroutines.JobSupport.attachChild.<anonymous>' call
            var addedBeforeCancellation = list.f1k(node, 7);
            var tmp;
            if (addedBeforeCancellation) {
              tmp = true;
            } else {
              var addedBeforeCompletion = list.f1k(node, 3);
              var latestState = this.o1f();
              var tmp_0;
              if (latestState instanceof Finishing) {
                tmp_0 = latestState.c1m();
              } else {
                // Inline function 'kotlinx.coroutines.assert' call
                var tmp0_safe_receiver = latestState instanceof CompletedExceptionally ? latestState : null;
                tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1f_1;
              }
              var rootCause = tmp_0;
              node.w1i(rootCause);
              var tmp_1;
              if (addedBeforeCompletion) {
                // Inline function 'kotlinx.coroutines.assert' call
                tmp_1 = true;
              } else {
                return NonDisposableHandle_instance;
              }
              tmp = tmp_1;
            }
            if (tmp) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
          }
        } else {
          tmp$ret$1 = false;
          break $l$block_1;
        }
      }
    }
  }
  var added = tmp$ret$1;
  if (added) return node;
  var tmp_2 = this.o1f();
  var tmp0_safe_receiver_0 = tmp_2 instanceof CompletedExceptionally ? tmp_2 : null;
  node.w1i(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.a1f_1);
  return NonDisposableHandle_instance;
};
protoOf(JobSupport).g1f = function (exception) {
  throw exception;
};
protoOf(JobSupport).g1g = function (cause) {};
protoOf(JobSupport).h1g = function () {
  return false;
};
protoOf(JobSupport).i1g = function () {
  return true;
};
protoOf(JobSupport).j1g = function (exception) {
  return false;
};
protoOf(JobSupport).z1e = function (state) {};
protoOf(JobSupport).f1f = function (state) {};
protoOf(JobSupport).toString = function () {
  return this.k1g() + '@' + get_hexAddress(this);
};
protoOf(JobSupport).k1g = function () {
  return this.h1f() + '{' + stateString(this, this.o1f()) + '}';
};
protoOf(JobSupport).h1f = function () {
  return get_classSimpleName(this);
};
protoOf(JobSupport).l1g = function () {
  var state = this.o1f();
  // Inline function 'kotlin.check' call
  if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
    // Inline function 'kotlinx.coroutines.JobSupport.getCompletionExceptionOrNull.<anonymous>' call
    var message = 'This job has not completed yet';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  return _get_exceptionOrNull__b3j7js(state);
};
protoOf(JobSupport).m1g = function () {
  var state = this.o1f();
  // Inline function 'kotlin.check' call
  if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
    // Inline function 'kotlinx.coroutines.JobSupport.getCompletedInternal.<anonymous>' call
    var message = 'This job has not completed yet';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  if (state instanceof CompletedExceptionally) throw state.a1f_1;
  return unboxState(state);
};
function boxIncomplete(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
    tmp = new IncompleteStateBox(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function InactiveNodeList(list) {
  this.y1l_1 = list;
}
protoOf(InactiveNodeList).b1k = function () {
  return this.y1l_1;
};
protoOf(InactiveNodeList).v1e = function () {
  return false;
};
protoOf(InactiveNodeList).toString = function () {
  return get_DEBUG() ? this.y1l_1.q1l('New') : anyToString(this);
};
function InvokeOnCompletion(handler) {
  JobNode.call(this);
  this.w1m_1 = handler;
}
protoOf(InvokeOnCompletion).v1j = function () {
  return false;
};
protoOf(InvokeOnCompletion).w1i = function (cause) {
  return this.w1m_1(cause);
};
function InvokeOnCancelling(handler) {
  JobNode.call(this);
  this.b1n_1 = handler;
  this.c1n_1 = atomic$boolean$1(false);
}
protoOf(InvokeOnCancelling).v1j = function () {
  return true;
};
protoOf(InvokeOnCancelling).w1i = function (cause) {
  if (this.c1n_1.atomicfu$compareAndSet(false, true)) this.b1n_1(cause);
};
function ChildHandleNode(childJob) {
  JobNode.call(this);
  this.i1m_1 = childJob;
}
protoOf(ChildHandleNode).v1j = function () {
  return true;
};
protoOf(ChildHandleNode).w1i = function (cause) {
  return this.i1m_1.a1g(this.a1k());
};
protoOf(ChildHandleNode).b1g = function (cause) {
  return this.a1k().b1g(cause);
};
function unboxState(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d1n_1;
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function IncompleteStateBox(state) {
  this.d1n_1 = state;
}
function handlesExceptionF($this) {
  var tmp = $this.n1f();
  var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1k();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parentJob = tmp_0;
  while (true) {
    if (parentJob.i1g()) return true;
    var tmp_1 = parentJob.n1f();
    var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.a1k();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    parentJob = tmp_2;
  }
}
function JobImpl(parent) {
  JobSupport.call(this, true);
  this.q1e(parent);
  this.g1n_1 = handlesExceptionF(this);
}
protoOf(JobImpl).z1f = function () {
  return true;
};
protoOf(JobImpl).i1g = function () {
  return this.g1n_1;
};
var properties_initialized_JobSupport_kt_5iq8a4;
function _init_properties_JobSupport_kt__68f172() {
  if (!properties_initialized_JobSupport_kt_5iq8a4) {
    properties_initialized_JobSupport_kt_5iq8a4 = true;
    COMPLETING_ALREADY = new _Symbol('COMPLETING_ALREADY');
    COMPLETING_WAITING_CHILDREN = new _Symbol('COMPLETING_WAITING_CHILDREN');
    COMPLETING_RETRY = new _Symbol('COMPLETING_RETRY');
    TOO_LATE_TO_CANCEL = new _Symbol('TOO_LATE_TO_CANCEL');
    SEALED = new _Symbol('SEALED');
    EMPTY_NEW = new Empty(false);
    EMPTY_ACTIVE = new Empty(true);
  }
}
function MainCoroutineDispatcher() {
  CoroutineDispatcher.call(this);
}
protoOf(MainCoroutineDispatcher).toString = function () {
  var tmp0_elvis_lhs = this.j1n();
  return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
};
protoOf(MainCoroutineDispatcher).j1n = function () {
  var main = Dispatchers_getInstance().o1n();
  if (this === main) return 'Dispatchers.Main';
  var tmp;
  try {
    tmp = main.i1n();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof UnsupportedOperationException) {
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  var immediate = tmp;
  if (this === immediate) return 'Dispatchers.Main.immediate';
  return null;
};
function SupervisorJob(parent) {
  parent = parent === VOID ? null : parent;
  return new SupervisorJobImpl(parent);
}
function SupervisorJobImpl(parent) {
  JobImpl.call(this, parent);
}
protoOf(SupervisorJobImpl).b1g = function (cause) {
  return false;
};
function TimeoutCancellationException(message, coroutine) {
  CancellationException_init_$Init$_0(message, this);
  captureStack(this, TimeoutCancellationException);
  this.s1n_1 = coroutine;
}
function withTimeoutOrNull(timeMillis, block, $completion) {
  var tmp = new $withTimeoutOrNullCOROUTINE$1(timeMillis, block, $completion);
  tmp.v7_1 = Unit_instance;
  tmp.w7_1 = null;
  return tmp.l8();
}
function TimeoutCoroutine(time, uCont) {
  ScopeCoroutine.call(this, uCont.z7(), uCont);
  this.i1o_1 = time;
}
protoOf(TimeoutCoroutine).n1j = function () {
  this.c1g(TimeoutCancellationException_0(this.i1o_1, get_delay(this.t1e_1), this));
};
protoOf(TimeoutCoroutine).h1f = function () {
  return protoOf(ScopeCoroutine).h1f.call(this) + '(timeMillis=' + this.i1o_1.toString() + ')';
};
function setupTimeout(coroutine, block) {
  var cont = coroutine.m1o_1;
  var context = cont.z7();
  disposeOnCompletion(coroutine, get_delay(context).p1k(coroutine.i1o_1, coroutine, coroutine.t1e_1));
  return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
}
function TimeoutCancellationException_0(time, delay, coroutine) {
  var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics) ? delay : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance_16();
    var tmp$ret$0 = toDuration_0(time, DurationUnit_MILLISECONDS_getInstance());
    tmp = tmp0_safe_receiver.q1k(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  var message = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
  return new TimeoutCancellationException(message, coroutine);
}
function $withTimeoutOrNullCOROUTINE$1(timeMillis, block, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b1o_1 = timeMillis;
  this.c1o_1 = block;
}
protoOf($withTimeoutOrNullCOROUTINE$1).l8 = function () {
  var suspendResult = this.v7_1;
  $sm: do {
    try {
      var tmp = this.t7_1;
      switch (tmp) {
        case 0:
          this.u7_1 = 3;
          if (this.b1o_1.z(new Long(0, 0)) <= 0) return null;
          this.d1o_1 = {
            _v: null
          };
          this.u7_1 = 2;
          this.t7_1 = 1;
          var timeoutCoroutine = new TimeoutCoroutine(this.b1o_1, this);
          this.d1o_1._v = timeoutCoroutine;
          suspendResult = returnIfSuspended(setupTimeout(timeoutCoroutine, this.c1o_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }
          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          this.u7_1 = 3;
          var tmp_0 = this.w7_1;
          if (tmp_0 instanceof TimeoutCancellationException) {
            var e = this.w7_1;
            if (e.s1n_1 === this.d1o_1._v) {
              return null;
            }
            throw e;
          } else {
            throw this.w7_1;
          }
        case 3:
          throw this.w7_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.u7_1 === 3) {
        throw e_0;
      } else {
        this.t7_1 = this.u7_1;
        this.w7_1 = e_0;
      }
    }
  } while (true);
};
function Unconfined() {
  Unconfined_instance = this;
  CoroutineDispatcher.call(this);
}
protoOf(Unconfined).j1k = function (context) {
  return false;
};
protoOf(Unconfined).k1k = function (context, block) {
  var yieldContext = context.s8(Key_instance_3);
  if (!(yieldContext == null)) {
    yieldContext.q1o_1 = true;
    return Unit_instance;
  }
  throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
};
protoOf(Unconfined).toString = function () {
  return 'Dispatchers.Unconfined';
};
var Unconfined_instance;
function Unconfined_getInstance() {
  if (Unconfined_instance == null) new Unconfined();
  return Unconfined_instance;
}
function Key_2() {}
var Key_instance_3;
function Waiter() {}
function get_CLOSED() {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  return CLOSED;
}
var CLOSED;
function Segment(id, prev, pointers) {
  ConcurrentLinkedListNode.call(this, prev);
  this.b1i_1 = id;
  this.c1i_1 = atomic$int$1(pointers << 16);
}
protoOf(Segment).s1o = function () {
  return this.c1i_1.kotlinx$atomicfu$value === this.r1o() && !this.v1o();
};
protoOf(Segment).w1o = function () {
  var tmp0 = this.c1i_1;
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.internal.addConditionally' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.internal.Segment.tryIncPointers.<anonymous>' call
      if (!(!(cur === this.r1o()) || this.v1o())) {
        tmp$ret$1 = false;
        break $l$block_0;
      }
      if (tmp0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
        tmp$ret$1 = true;
        break $l$block_0;
      }
    }
  }
  return tmp$ret$1;
};
protoOf(Segment).x1o = function () {
  return this.c1i_1.atomicfu$addAndGet(-65536) === this.r1o() && !this.v1o();
};
protoOf(Segment).y1o = function () {
  if (this.c1i_1.atomicfu$incrementAndGet() === this.r1o()) {
    this.u3();
  }
};
function _SegmentOrClosed___init__impl__jnexvb(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
  return _get_value__a43j40($this) === get_CLOSED();
}
function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
  var tmp;
  if (_get_value__a43j40($this) === get_CLOSED()) {
    var message = 'Does not contain segment';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  } else {
    var tmp_0 = _get_value__a43j40($this);
    tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
  }
  return tmp;
}
function _get_nextOrClosed__w0gmuv($this) {
  return $this.t1o_1.kotlinx$atomicfu$value;
}
function _get_aliveSegmentLeft__mr4ndu($this) {
  var cur = $this.b1p();
  while (!(cur === null) && cur.s1o()) {
    cur = cur.u1o_1.kotlinx$atomicfu$value;
  }
  return cur;
}
function _get_aliveSegmentRight__7ulr0b($this) {
  // Inline function 'kotlinx.coroutines.assert' call
  var cur = ensureNotNull($this.z1o());
  while (cur.s1o()) {
    var tmp0_elvis_lhs = cur.z1o();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return cur;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    cur = tmp;
  }
  return cur;
}
function access$_get_nextOrClosed__ywzond($this) {
  return _get_nextOrClosed__w0gmuv($this);
}
function ConcurrentLinkedListNode(prev) {
  this.t1o_1 = atomic$ref$1(null);
  this.u1o_1 = atomic$ref$1(prev);
}
protoOf(ConcurrentLinkedListNode).z1o = function () {
  // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
  var it = access$_get_nextOrClosed__ywzond(this);
  var tmp;
  if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.<get-next>.<anonymous>' call
    return null;
  } else {
    tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
  }
  return tmp;
};
protoOf(ConcurrentLinkedListNode).a1p = function (value) {
  return this.t1o_1.atomicfu$compareAndSet(null, value);
};
protoOf(ConcurrentLinkedListNode).v1o = function () {
  return this.z1o() == null;
};
protoOf(ConcurrentLinkedListNode).b1p = function () {
  return this.u1o_1.kotlinx$atomicfu$value;
};
protoOf(ConcurrentLinkedListNode).c1p = function () {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  this.u1o_1.kotlinx$atomicfu$value = null;
};
protoOf(ConcurrentLinkedListNode).u3 = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  if (this.v1o()) return Unit_instance;
  $l$loop_0: while (true) {
    var prev = _get_aliveSegmentLeft__mr4ndu(this);
    var next = _get_aliveSegmentRight__7ulr0b(this);
    var tmp0 = next.u1o_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.remove.<anonymous>' call
        var upd = cur === null ? null : prev;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    if (!(prev === null)) prev.t1o_1.kotlinx$atomicfu$value = next;
    if (next.s1o() && !next.v1o()) continue $l$loop_0;
    if (!(prev === null) && prev.s1o()) continue $l$loop_0;
    return Unit_instance;
  }
};
function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  $l$loop: while (cur.b1i_1.z(id) < 0 || cur.s1o()) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
    var it = access$_get_nextOrClosed__ywzond(this_0);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      // Inline function 'kotlinx.coroutines.internal.findSegmentInternal.<anonymous>' call
      return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (!(next == null)) {
      cur = next;
      continue $l$loop;
    }
    // Inline function 'kotlin.Long.plus' call
    var newTail = createNewSegment(cur.b1i_1.i2(toLong(1)), cur);
    if (cur.a1p(newTail)) {
      if (cur.s1o()) {
        cur.u3();
      }
      cur = newTail;
    }
  }
  return _SegmentOrClosed___init__impl__jnexvb(cur);
}
function access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy() {
  return get_CLOSED();
}
var properties_initialized_ConcurrentLinkedList_kt_kwt434;
function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
  if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
    properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
    CLOSED = new _Symbol('CLOSED');
  }
}
function handleUncaughtCoroutineException(context, exception) {
  var _iterator__ex2g4s = get_platformExceptionHandlers().i();
  while (_iterator__ex2g4s.j()) {
    var handler = _iterator__ex2g4s.k();
    try {
      handler.n1k(context, exception);
    } catch ($p) {
      if ($p instanceof ExceptionSuccessfullyProcessed) {
        return Unit_instance;
      } else {
        if ($p instanceof Error) {
          var t = $p;
          propagateExceptionFinalResort(handlerException(exception, t));
        } else {
          throw $p;
        }
      }
    }
  }
  try {
    addSuppressed(exception, new DiagnosticCoroutineContextException(context));
  } catch ($p) {
    if ($p instanceof Error) ; else {
      throw $p;
    }
  }
  propagateExceptionFinalResort(exception);
}
function ExceptionSuccessfullyProcessed() {}
function get_UNDEFINED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return UNDEFINED;
}
var UNDEFINED;
function get_REUSABLE_CLAIMED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return REUSABLE_CLAIMED;
}
var REUSABLE_CLAIMED;
function _get_reusableCancellableContinuation__9qex09($this) {
  var tmp = $this.t1h_1.kotlinx$atomicfu$value;
  return tmp instanceof CancellableContinuationImpl ? tmp : null;
}
function DispatchedContinuation(dispatcher, continuation) {
  DispatchedTask.call(this, -1);
  this.p1h_1 = dispatcher;
  this.q1h_1 = continuation;
  this.r1h_1 = get_UNDEFINED();
  this.s1h_1 = threadContextElements(this.z7());
  this.t1h_1 = atomic$ref$1(null);
}
protoOf(DispatchedContinuation).w1h = function () {
  return !(this.t1h_1.kotlinx$atomicfu$value == null);
};
protoOf(DispatchedContinuation).d1p = function () {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.t1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.awaitReusability.<anonymous>' call
    if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED())) return Unit_instance;
  }
};
protoOf(DispatchedContinuation).l1k = function () {
  this.d1p();
  var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
  if (tmp0_safe_receiver == null) ;else {
    tmp0_safe_receiver.n1i();
  }
};
protoOf(DispatchedContinuation).u1h = function () {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.t1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.claimReusableCancellableContinuation.<anonymous>' call
    var state = this_0.kotlinx$atomicfu$value;
    if (state === null) {
      this.t1h_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
      return null;
    } else {
      if (state instanceof CancellableContinuationImpl) {
        if (this.t1h_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
          return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
        }
      } else {
        if (state !== get_REUSABLE_CLAIMED()) {
          if (!(state instanceof Error)) {
            // Inline function 'kotlin.error' call
            var message = 'Inconsistent state ' + toString_0(state);
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }
      }
    }
  }
};
protoOf(DispatchedContinuation).c1j = function (continuation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.t1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.tryReleaseClaimedContinuation.<anonymous>' call
    var state = this_0.kotlinx$atomicfu$value;
    if (state === get_REUSABLE_CLAIMED()) {
      if (this.t1h_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation)) return null;
    } else {
      if (state instanceof Error) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!this.t1h_1.atomicfu$compareAndSet(state, null)) {
          // Inline function 'kotlin.require.<anonymous>' call
          var message = 'Failed requirement.';
          throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }
        return state;
      } else {
        // Inline function 'kotlin.error' call
        var message_0 = 'Inconsistent state ' + toString_0(state);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
    }
  }
};
protoOf(DispatchedContinuation).y1h = function (cause) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.t1h_1;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.postponeCancellation.<anonymous>' call
    var state = this_0.kotlinx$atomicfu$value;
    if (equals(state, get_REUSABLE_CLAIMED())) {
      if (this.t1h_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause)) return true;
    } else {
      if (state instanceof Error) return true;else {
        if (this.t1h_1.atomicfu$compareAndSet(state, null)) return false;
      }
    }
  }
};
protoOf(DispatchedContinuation).r1i = function () {
  var state = this.r1h_1;
  // Inline function 'kotlinx.coroutines.assert' call
  this.r1h_1 = get_UNDEFINED();
  return state;
};
protoOf(DispatchedContinuation).o1i = function () {
  return this;
};
protoOf(DispatchedContinuation).o8 = function (result) {
  var state = toState_0(result);
  if (safeIsDispatchNeeded(this.p1h_1, this.z7())) {
    this.r1h_1 = state;
    this.x1h_1 = 0;
    safeDispatch(this.p1h_1, this.z7(), this);
  } else {
    {
      // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
      // Inline function 'kotlinx.coroutines.assert' call
      var eventLoop = ThreadLocalEventLoop_getInstance().d1l();
      if (eventLoop.x1k()) {
        this.r1h_1 = state;
        this.x1h_1 = 0;
        eventLoop.w1k(this);
      } else {
        // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
        eventLoop.z1k(true);
        try {
          // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeWith.<anonymous>' call
          this.z7();
          // Inline function 'kotlinx.coroutines.withCoroutineContext' call
          this.s1h_1;
          // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeWith.<anonymous>.<anonymous>' call
          this.q1h_1.o8(result);
          $l$loop: while (eventLoop.v1k()) {}
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            this.o1j(e);
          } else {
            throw $p;
          }
        } finally {
          eventLoop.a1l(true);
        }
      }
    }
  }
};
protoOf(DispatchedContinuation).toString = function () {
  return 'DispatchedContinuation[' + this.p1h_1.toString() + ', ' + toDebugString(this.q1h_1) + ']';
};
protoOf(DispatchedContinuation).z7 = function () {
  return this.q1h_1.z7();
};
function safeDispatch(_this__u8e3s4, context, runnable) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    _this__u8e3s4.k1k(context, runnable);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw new DispatchException(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function safeIsDispatchNeeded(_this__u8e3s4, context) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    return _this__u8e3s4.j1k(context);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw new DispatchException(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function resumeCancellableWith(_this__u8e3s4, result) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp;
  if (_this__u8e3s4 instanceof DispatchedContinuation) {
    var state = toState_0(result);
    if (safeIsDispatchNeeded(_this__u8e3s4.p1h_1, _this__u8e3s4.z7())) {
      _this__u8e3s4.r1h_1 = state;
      _this__u8e3s4.x1h_1 = 1;
      safeDispatch(_this__u8e3s4.p1h_1, _this__u8e3s4.z7(), _this__u8e3s4);
    } else {
      {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().d1l();
        if (eventLoop.x1k()) {
          _this__u8e3s4.r1h_1 = state;
          _this__u8e3s4.x1h_1 = 1;
          eventLoop.w1k(_this__u8e3s4);
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.z1k(true);
          try {
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith.<anonymous>' call
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
              var job = _this__u8e3s4.z7().s8(Key_instance_2);
              if (!(job == null) && !job.v1e()) {
                var cause = job.s1f();
                _this__u8e3s4.s1i(state, cause);
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
                _this__u8e3s4.o8(tmp$ret$1);
                tmp$ret$3 = true;
                break $l$block_0;
              }
              tmp$ret$3 = false;
            }
            if (!tmp$ret$3) {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
              _this__u8e3s4.q1h_1;
              // Inline function 'kotlinx.coroutines.withContinuationContext' call
              _this__u8e3s4.s1h_1;
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith.<anonymous>' call
              _this__u8e3s4.q1h_1.o8(result);
            }
            $l$loop: while (eventLoop.v1k()) {}
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              _this__u8e3s4.o1j(e);
            } else {
              throw $p;
            }
          } finally {
            eventLoop.a1l(true);
          }
        }
      }
    }
    tmp = Unit_instance;
  } else {
    _this__u8e3s4.o8(result);
    tmp = Unit_instance;
  }
  return tmp;
}
var properties_initialized_DispatchedContinuation_kt_2siadq;
function _init_properties_DispatchedContinuation_kt__tnmqc0() {
  if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
    properties_initialized_DispatchedContinuation_kt_2siadq = true;
    UNDEFINED = new _Symbol('UNDEFINED');
    REUSABLE_CLAIMED = new _Symbol('REUSABLE_CLAIMED');
  }
}
function DispatchedTask(resumeMode) {
  SchedulerTask.call(this);
  this.x1h_1 = resumeMode;
}
protoOf(DispatchedTask).s1i = function (takenState, cause) {};
protoOf(DispatchedTask).b1j = function (state) {
  return (state == null ? true : !(state == null)) ? state : THROW_CCE();
};
protoOf(DispatchedTask).l1j = function (state) {
  var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a1f_1;
};
protoOf(DispatchedTask).n1j = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  try {
    var tmp = this.o1i();
    var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
    var continuation = delegate.q1h_1;
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    delegate.s1h_1;
    // Inline function 'kotlinx.coroutines.DispatchedTask.run.<anonymous>' call
    var context = continuation.z7();
    var state = this.r1i();
    var exception = this.l1j(state);
    var job = exception == null && get_isCancellableMode(this.x1h_1) ? context.s8(Key_instance_2) : null;
    if (!(job == null) && !job.v1e()) {
      var cause = job.s1f();
      this.s1i(state, cause);
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      // Inline function 'kotlin.Companion.failure' call
      var exception_0 = recoverStackTrace(cause, continuation);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception_0));
      continuation.o8(tmp$ret$0);
    } else {
      if (!(exception == null)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
        continuation.o8(tmp$ret$1);
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = this.b1j(state);
        var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
        continuation.o8(tmp$ret$3);
      }
    }
  } catch ($p) {
    if ($p instanceof DispatchException) {
      var e = $p;
      handleCoroutineException(this.o1i().z7(), e.m1k_1);
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.o1j(e_0);
      } else {
        throw $p;
      }
    }
  }
};
protoOf(DispatchedTask).o1j = function (exception) {
  var reason = new CoroutinesInternalError('Fatal exception in coroutines machinery for ' + toString_1(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", exception);
  handleCoroutineException(this.o1i().z7(), reason);
};
function get_isReusableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 2;
}
function get_isCancellableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
}
function dispatch(_this__u8e3s4, mode) {
  // Inline function 'kotlinx.coroutines.assert' call
  var delegate = _this__u8e3s4.o1i();
  var undispatched = mode === 4;
  var tmp;
  var tmp_0;
  if (!undispatched) {
    tmp_0 = delegate instanceof DispatchedContinuation;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.x1h_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    var dispatcher = delegate.p1h_1;
    var context = delegate.z7();
    if (safeIsDispatchNeeded(dispatcher, context)) {
      safeDispatch(dispatcher, context, _this__u8e3s4);
    } else {
      resumeUnconfined(_this__u8e3s4);
    }
  } else {
    resume(_this__u8e3s4, delegate, undispatched);
  }
}
function DispatchException(cause, dispatcher, context) {
  Exception_init_$Init$_1('Coroutine dispatcher ' + dispatcher.toString() + ' threw an exception, context = ' + toString_1(context), cause, this);
  captureStack(this, DispatchException);
  this.m1k_1 = cause;
}
protoOf(DispatchException).w8 = function () {
  return this.m1k_1;
};
function resumeUnconfined(_this__u8e3s4) {
  var eventLoop = ThreadLocalEventLoop_getInstance().d1l();
  if (eventLoop.x1k()) {
    eventLoop.w1k(_this__u8e3s4);
  } else {
    // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
    eventLoop.z1k(true);
    try {
      // Inline function 'kotlinx.coroutines.resumeUnconfined.<anonymous>' call
      resume(_this__u8e3s4, _this__u8e3s4.o1i(), true);
      $l$loop: while (eventLoop.v1k()) {}
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        _this__u8e3s4.o1j(e);
      } else {
        throw $p;
      }
    } finally {
      eventLoop.a1l(true);
    }
  }
}
function resume(_this__u8e3s4, delegate, undispatched) {
  var state = _this__u8e3s4.r1i();
  var exception = _this__u8e3s4.l1j(state);
  var tmp;
  if (!(exception == null)) {
    // Inline function 'kotlin.Companion.failure' call
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = _this__u8e3s4.b1j(state);
    tmp = _Result___init__impl__xyqfz8(value);
  }
  var result = tmp;
  if (undispatched) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
    var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
    this_0.q1h_1;
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    this_0.s1h_1;
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith.<anonymous>' call
    this_0.q1h_1.o8(result);
  } else {
    delegate.o8(result);
  }
}
function ContextScope(context) {
  this.e1p_1 = context;
}
protoOf(ContextScope).u1e = function () {
  return this.e1p_1;
};
protoOf(ContextScope).toString = function () {
  return 'CoroutineScope(coroutineContext=' + toString_1(this.e1p_1) + ')';
};
function ScopeCoroutine(context, uCont) {
  AbstractCoroutine.call(this, context, true, true);
  this.m1o_1 = uCont;
}
protoOf(ScopeCoroutine).h1g = function () {
  return true;
};
protoOf(ScopeCoroutine).f1f = function (state) {
  resumeCancellableWith(intercepted(this.m1o_1), recoverResult(state, this.m1o_1));
};
protoOf(ScopeCoroutine).n1o = function () {};
protoOf(ScopeCoroutine).e1f = function (state) {
  this.m1o_1.o8(recoverResult(state, this.m1o_1));
};
function _Symbol(symbol) {
  this.f1p_1 = symbol;
}
protoOf(_Symbol).toString = function () {
  return '<' + this.f1p_1 + '>';
};
function systemProp(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? 1 : minValue;
  maxValue = maxValue === VOID ? 2147483647 : maxValue;
  return systemProp_0(propertyName, toLong(defaultValue), toLong(minValue), toLong(maxValue)).b1();
}
function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? new Long(1, 0) : minValue;
  maxValue = maxValue === VOID ? new Long(-1, 2147483647) : maxValue;
  {
    return defaultValue;
  }
}
function startCoroutineCancellable(_this__u8e3s4, fatalCompletion) {
  var tmp;
  try {
    var tmp_0 = intercepted(_this__u8e3s4);
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp_0, tmp$ret$0);
    tmp = Unit_instance;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(fatalCompletion, e);
      tmp_1 = Unit_instance;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function startCoroutineCancellable_0(_this__u8e3s4, receiver, completion) {
  var tmp;
  try {
    var tmp_0 = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp_0, tmp$ret$0);
    tmp = Unit_instance;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
      tmp_1 = Unit_instance;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function dispatcherFailure(completion, e) {
  var tmp;
  if (e instanceof DispatchException) {
    tmp = e.m1k_1;
  } else {
    tmp = e;
  }
  var reportException = tmp;
  // Inline function 'kotlin.Companion.failure' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(reportException));
  completion.o8(tmp$ret$0);
  throw reportException;
}
function startUndispatchedOrReturnIgnoreTimeout(_this__u8e3s4, receiver, block) {
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
    var tmp;
    try {
      // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturnIgnoreTimeout.<anonymous>' call
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, receiver, _this__u8e3s4);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        tmp_0 = new CompletedExceptionally(e);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var result = tmp;
    if (result === get_COROUTINE_SUSPENDED()) {
      tmp$ret$2 = get_COROUTINE_SUSPENDED();
      break $l$block_0;
    }
    var state = _this__u8e3s4.d1f(result);
    if (state === get_COMPLETING_WAITING_CHILDREN()) {
      tmp$ret$2 = get_COROUTINE_SUSPENDED();
      break $l$block_0;
    }
    _this__u8e3s4.n1o();
    var tmp_1;
    if (state instanceof CompletedExceptionally) {
      var tmp_2;
      // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturnIgnoreTimeout.<anonymous>' call
      var e_0 = state.a1f_1;
      var tmp_3;
      if (e_0 instanceof TimeoutCancellationException) {
        tmp_3 = e_0.s1n_1 === _this__u8e3s4;
      } else {
        tmp_3 = false;
      }
      if (!tmp_3) {
        throw recoverStackTrace(state.a1f_1, _this__u8e3s4.m1o_1);
      } else {
        if (result instanceof CompletedExceptionally) {
          throw recoverStackTrace(result.a1f_1, _this__u8e3s4.m1o_1);
        } else {
          tmp_2 = result;
        }
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = unboxState(state);
    }
    tmp$ret$2 = tmp_1;
  }
  return tmp$ret$2;
}
function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
  var actualCompletion = completion;
  var tmp;
  try {
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    actualCompletion.z7();
    // Inline function 'kotlinx.coroutines.intrinsics.startCoroutineUndispatched.<anonymous>' call
    // Inline function 'kotlinx.coroutines.internal.probeCoroutineResumed' call
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      var tmp_1;
      if (e instanceof DispatchException) {
        tmp_1 = e.m1k_1;
      } else {
        tmp_1 = e;
      }
      var reportException = tmp_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(reportException));
      actualCompletion.o8(tmp$ret$4);
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  var value = tmp;
  if (!(value === get_COROUTINE_SUSPENDED())) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    var tmp$ret$6 = _Result___init__impl__xyqfz8(value_0);
    actualCompletion.o8(tmp$ret$6);
  }
}
function SelectInstance() {}
function get_NO_OWNER() {
  _init_properties_Mutex_kt__jod56b();
  return NO_OWNER;
}
var NO_OWNER;
function Mutex(locked) {
  locked = locked === VOID ? false : locked;
  _init_properties_Mutex_kt__jod56b();
  return new MutexImpl(locked);
}
function MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this$0, this$1) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.p1p_1.kotlinx$atomicfu$value = this$1.s1p_1;
    this$0.u1p(this$1.s1p_1);
    return Unit_instance;
  };
}
function MutexImpl$CancellableContinuationWithOwner$resume$lambda(this$0, this$1) {
  return function (it) {
    this$0.u1p(this$1.s1p_1);
    return Unit_instance;
  };
}
function holdsLockImpl($this, owner) {
  $l$loop: while (true) {
    if (!$this.v1p()) return 0;
    var curOwner = $this.p1p_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER()) continue $l$loop;
    return curOwner === owner ? 1 : 2;
  }
}
function lockSuspend($this, owner, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    // Inline function 'kotlinx.coroutines.sync.MutexImpl.lockSuspend.<anonymous>' call
    var contWithOwner = new CancellableContinuationWithOwner($this, cancellable, owner);
    $this.acquireCont(contWithOwner);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.a1j();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.z1i();
}
function tryLockImpl($this, owner) {
  $l$loop: while (true) {
    if ($this.d1q()) {
      // Inline function 'kotlinx.coroutines.assert' call
      $this.p1p_1.kotlinx$atomicfu$value = owner;
      return 0;
    } else {
      if (owner == null) return 1;
      switch (holdsLockImpl($this, owner)) {
        case 1:
          return 2;
        case 2:
          return 1;
        case 0:
          continue $l$loop;
      }
    }
  }
}
function CancellableContinuationWithOwner($outer, cont, owner) {
  this.t1p_1 = $outer;
  this.r1p_1 = cont;
  this.s1p_1 = owner;
}
protoOf(CancellableContinuationWithOwner).e1q = function (value, idempotent, onCancellation) {
  // Inline function 'kotlinx.coroutines.assert' call
  var token = this.r1p_1.d1h(value, idempotent, MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this.t1p_1, this));
  if (!(token == null)) {
    // Inline function 'kotlinx.coroutines.assert' call
    this.t1p_1.p1p_1.kotlinx$atomicfu$value = this.s1p_1;
  }
  return token;
};
protoOf(CancellableContinuationWithOwner).d1h = function (value, idempotent, onCancellation) {
  return this.e1q(value instanceof Unit ? value : THROW_CCE(), idempotent, onCancellation);
};
protoOf(CancellableContinuationWithOwner).f1q = function (value, onCancellation) {
  // Inline function 'kotlinx.coroutines.assert' call
  this.t1p_1.p1p_1.kotlinx$atomicfu$value = this.s1p_1;
  this.r1p_1.e1j(Unit_instance, MutexImpl$CancellableContinuationWithOwner$resume$lambda(this.t1p_1, this));
};
protoOf(CancellableContinuationWithOwner).g1h = function (value, onCancellation) {
  return this.f1q(value instanceof Unit ? value : THROW_CCE(), onCancellation);
};
protoOf(CancellableContinuationWithOwner).e1h = function (token) {
  this.r1p_1.e1h(token);
};
protoOf(CancellableContinuationWithOwner).g1j = function (segment, index) {
  this.r1p_1.g1j(segment, index);
};
protoOf(CancellableContinuationWithOwner).g1q = function (_this__u8e3s4, value) {
  this.r1p_1.f1h(_this__u8e3s4, Unit_instance);
};
protoOf(CancellableContinuationWithOwner).f1h = function (_this__u8e3s4, value) {
  return this.g1q(_this__u8e3s4, value instanceof Unit ? value : THROW_CCE());
};
protoOf(CancellableContinuationWithOwner).h1q = function (result) {
  this.r1p_1.o8(result);
};
protoOf(CancellableContinuationWithOwner).o8 = function (result) {
  return this.h1q(result);
};
protoOf(CancellableContinuationWithOwner).z7 = function () {
  return this.r1p_1.z7();
};
function MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, $owner) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.u1p($owner);
    return Unit_instance;
  };
}
function MutexImpl$onSelectCancellationUnlockConstructor$lambda(this$0) {
  return function (_unused_var__etf5q3, owner, _unused_var__etf5q3_0) {
    return MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, owner);
  };
}
function MutexImpl(locked) {
  SemaphoreAndMutexImpl.call(this, 1, locked ? 1 : 0);
  this.p1p_1 = atomic$ref$1(locked ? null : get_NO_OWNER());
  var tmp = this;
  tmp.q1p_1 = MutexImpl$onSelectCancellationUnlockConstructor$lambda(this);
}
protoOf(MutexImpl).v1p = function () {
  return this.i1q() === 0;
};
protoOf(MutexImpl).j1q = function (owner, $completion) {
  if (this.k1q(owner)) return Unit_instance;
  return lockSuspend(this, owner, $completion);
};
protoOf(MutexImpl).k1q = function (owner) {
  var tmp;
  switch (tryLockImpl(this, owner)) {
    case 0:
      tmp = true;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      var message = 'This mutex is already locked by the specified owner: ' + toString_0(owner);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    default:
      var message_0 = 'unexpected';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
  }
  return tmp;
};
protoOf(MutexImpl).u1p = function (owner) {
  $l$loop_0: while (true) {
    // Inline function 'kotlin.check' call
    if (!this.v1p()) {
      // Inline function 'kotlinx.coroutines.sync.MutexImpl.unlock.<anonymous>' call
      var message = 'This mutex is not locked';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var curOwner = this.p1p_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER()) continue $l$loop_0;
    // Inline function 'kotlin.check' call
    if (!(curOwner === owner || owner == null)) {
      // Inline function 'kotlinx.coroutines.sync.MutexImpl.unlock.<anonymous>' call
      var message_0 = 'This mutex is locked by ' + toString_0(curOwner) + ', but ' + toString_0(owner) + ' is expected';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    if (!this.p1p_1.atomicfu$compareAndSet(curOwner, get_NO_OWNER())) continue $l$loop_0;
    this.e13();
    return Unit_instance;
  }
};
protoOf(MutexImpl).toString = function () {
  return 'Mutex@' + get_hexAddress(this) + '[isLocked=' + this.v1p() + ',owner=' + toString_0(this.p1p_1.kotlinx$atomicfu$value) + ']';
};
var properties_initialized_Mutex_kt_yv4p3j;
function _init_properties_Mutex_kt__jod56b() {
  if (!properties_initialized_Mutex_kt_yv4p3j) {
    properties_initialized_Mutex_kt_yv4p3j = true;
    NO_OWNER = new _Symbol('NO_OWNER');
  }
}
function get_MAX_SPIN_CYCLES() {
  _init_properties_Semaphore_kt__t514r6();
  return MAX_SPIN_CYCLES;
}
var MAX_SPIN_CYCLES;
function get_PERMIT() {
  _init_properties_Semaphore_kt__t514r6();
  return PERMIT;
}
var PERMIT;
function get_TAKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return TAKEN;
}
var TAKEN;
function get_BROKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return BROKEN;
}
var BROKEN;
function get_CANCELLED() {
  _init_properties_Semaphore_kt__t514r6();
  return CANCELLED;
}
var CANCELLED;
function get_SEGMENT_SIZE() {
  _init_properties_Semaphore_kt__t514r6();
  return SEGMENT_SIZE;
}
var SEGMENT_SIZE;
function decPermits($this) {
  $l$loop: while (true) {
    var p = $this.b1q_1.atomicfu$getAndDecrement();
    if (p > $this.w1p_1) continue $l$loop;
    return p;
  }
}
function coerceAvailablePermitsAtMaximum($this) {
  $l$loop_0: while (true) {
    var cur = $this.b1q_1.kotlinx$atomicfu$value;
    if (cur <= $this.w1p_1) break $l$loop_0;
    if ($this.b1q_1.atomicfu$compareAndSet(cur, $this.w1p_1)) break $l$loop_0;
  }
}
function addAcquireToQueue($this, waiter) {
  var curTail = $this.z1p_1.kotlinx$atomicfu$value;
  var enqIdx = $this.a1q_1.atomicfu$getAndIncrement$long();
  var createNewSegment = createSegment$ref();
  var tmp2 = $this.z1p_1;
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE();
  var tmp3 = enqIdx.l2(toLong(other));
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curTail, tmp3, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur = tmp2.kotlinx$atomicfu$value;
            if (cur.b1i_1.z(tmp1.b1i_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp1.w1o()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp2.atomicfu$compareAndSet(cur, tmp1)) {
              if (cur.x1o()) {
                cur.u3();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp1.x1o()) {
              tmp1.u3();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$2);
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE();
  var i = enqIdx.m2(toLong(other_0)).b1();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  if (segment.p1q_1.atomicfu$get(i).atomicfu$compareAndSet(null, waiter)) {
    waiter.g1j(segment, i);
    return true;
  }
  var tmp14 = get_PERMIT();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  var value = get_TAKEN();
  if (segment.p1q_1.atomicfu$get(i).atomicfu$compareAndSet(tmp14, value)) {
    if (isInterface(waiter, CancellableContinuation)) {
      if (!isInterface(waiter, CancellableContinuation)) THROW_CCE();
      waiter.g1h(Unit_instance, $this.c1q_1);
    } else {
      if (isInterface(waiter, SelectInstance)) {
        waiter.h1p(Unit_instance);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unexpected: ' + toString_1(waiter);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return true;
  }
  // Inline function 'kotlinx.coroutines.assert' call
  return false;
}
function tryResumeNextFromQueue($this) {
  var curHead = $this.x1p_1.kotlinx$atomicfu$value;
  var deqIdx = $this.y1p_1.atomicfu$getAndIncrement$long();
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE();
  var id = deqIdx.l2(toLong(other));
  var createNewSegment = createSegment$ref_0();
  var tmp2 = $this.x1p_1;
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curHead, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur = tmp2.kotlinx$atomicfu$value;
            if (cur.b1i_1.z(tmp1.b1i_1) >= 0) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp1.w1o()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp2.atomicfu$compareAndSet(cur, tmp1)) {
              if (cur.x1o()) {
                cur.u3();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp1.x1o()) {
              tmp1.u3();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$2);
  segment.c1p();
  if (segment.b1i_1.z(id) > 0) return false;
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE();
  var i = deqIdx.m2(toLong(other_0)).b1();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.getAndSet' call
  var value = get_PERMIT();
  var cellState = segment.p1q_1.atomicfu$get(i).atomicfu$getAndSet(value);
  if (cellState === null) {
    // Inline function 'kotlin.repeat' call
    var times = get_MAX_SPIN_CYCLES();
    var inductionVariable = 0;
    if (inductionVariable < times) do {
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.tryResumeNextFromQueue.<anonymous>' call
      // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.get' call
      if (segment.p1q_1.atomicfu$get(i).kotlinx$atomicfu$value === get_TAKEN()) return true;
    } while (inductionVariable < times);
    var tmp15 = get_PERMIT();
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
    var value_0 = get_BROKEN();
    return !segment.p1q_1.atomicfu$get(i).atomicfu$compareAndSet(tmp15, value_0);
  } else if (cellState === get_CANCELLED()) return false;else return tryResumeAcquire(cellState, $this);
}
function tryResumeAcquire(_this__u8e3s4, $this) {
  var tmp;
  if (isInterface(_this__u8e3s4, CancellableContinuation)) {
    if (!isInterface(_this__u8e3s4, CancellableContinuation)) THROW_CCE();
    var token = _this__u8e3s4.d1h(Unit_instance, null, $this.c1q_1);
    var tmp_0;
    if (!(token == null)) {
      _this__u8e3s4.e1h(token);
      tmp_0 = true;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      tmp = _this__u8e3s4.g1p($this, Unit_instance);
    } else {
      var message = 'unexpected: ' + toString_1(_this__u8e3s4);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  return tmp;
}
function SemaphoreAndMutexImpl$onCancellationRelease$lambda(this$0) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.e13();
    return Unit_instance;
  };
}
function createSegment$ref() {
  var l = function l(p0, p1) {
    return createSegment(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function createSegment$ref_0() {
  var l = function l(p0, p1) {
    return createSegment(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function SemaphoreAndMutexImpl(permits, acquiredPermits) {
  this.w1p_1 = permits;
  this.y1p_1 = atomic$long$1(new Long(0, 0));
  this.a1q_1 = atomic$long$1(new Long(0, 0));
  // Inline function 'kotlin.require' call
  if (!(this.w1p_1 > 0)) {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.<anonymous>' call
    var message = 'Semaphore should have at least 1 permit, but had ' + this.w1p_1;
    throw IllegalArgumentException_init_$Create$_0(toString_1(message));
  }
  // Inline function 'kotlin.require' call
  if (!(0 <= acquiredPermits ? acquiredPermits <= this.w1p_1 : false)) {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.<anonymous>' call
    var message_0 = 'The number of acquired permits should be in 0..' + this.w1p_1;
    throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
  }
  var s = new SemaphoreSegment(new Long(0, 0), null, 2);
  this.x1p_1 = atomic$ref$1(s);
  this.z1p_1 = atomic$ref$1(s);
  this.b1q_1 = atomic$int$1(this.w1p_1 - acquiredPermits | 0);
  var tmp = this;
  tmp.c1q_1 = SemaphoreAndMutexImpl$onCancellationRelease$lambda(this);
}
protoOf(SemaphoreAndMutexImpl).i1q = function () {
  // Inline function 'kotlin.math.max' call
  var a = this.b1q_1.kotlinx$atomicfu$value;
  return Math.max(a, 0);
};
protoOf(SemaphoreAndMutexImpl).d1q = function () {
  $l$loop: while (true) {
    var p = this.b1q_1.kotlinx$atomicfu$value;
    if (p > this.w1p_1) {
      coerceAvailablePermitsAtMaximum(this);
      continue $l$loop;
    }
    if (p <= 0) return false;
    if (this.b1q_1.atomicfu$compareAndSet(p, p - 1 | 0)) return true;
  }
};
protoOf(SemaphoreAndMutexImpl).acquireCont = function (waiter) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire' call
    while (true) {
      var p = decPermits(this);
      if (p > 0) {
        // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire.<anonymous>' call
        waiter.g1h(Unit_instance, this.c1q_1);
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire.<anonymous>' call
      if (addAcquireToQueue(this, isInterface(waiter, Waiter) ? waiter : THROW_CCE())) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
    }
  }
  return tmp$ret$0;
};
protoOf(SemaphoreAndMutexImpl).e13 = function () {
  while (true) {
    var p = this.b1q_1.atomicfu$getAndIncrement();
    if (p >= this.w1p_1) {
      coerceAvailablePermitsAtMaximum(this);
      // Inline function 'kotlin.error' call
      var message = 'The number of released permits cannot be greater than ' + this.w1p_1;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (p >= 0) return Unit_instance;
    if (tryResumeNextFromQueue(this)) return Unit_instance;
  }
};
function SemaphoreSegment(id, prev, pointers) {
  Segment.call(this, id, prev, pointers);
  this.p1q_1 = atomicfu$AtomicRefArray$ofNulls(get_SEGMENT_SIZE());
}
protoOf(SemaphoreSegment).r1o = function () {
  return get_SEGMENT_SIZE();
};
protoOf(SemaphoreSegment).d1i = function (index, cause, context) {
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.set' call
  var value = get_CANCELLED();
  this.p1q_1.atomicfu$get(index).kotlinx$atomicfu$value = value;
  this.y1o();
};
protoOf(SemaphoreSegment).toString = function () {
  return 'SemaphoreSegment[id=' + this.b1i_1.toString() + ', hashCode=' + hashCode(this) + ']';
};
function createSegment(id, prev) {
  _init_properties_Semaphore_kt__t514r6();
  return new SemaphoreSegment(id, prev, 0);
}
var properties_initialized_Semaphore_kt_uqcwok;
function _init_properties_Semaphore_kt__t514r6() {
  if (!properties_initialized_Semaphore_kt_uqcwok) {
    properties_initialized_Semaphore_kt_uqcwok = true;
    MAX_SPIN_CYCLES = systemProp('kotlinx.coroutines.semaphore.maxSpinCycles', 100);
    PERMIT = new _Symbol('PERMIT');
    TAKEN = new _Symbol('TAKEN');
    BROKEN = new _Symbol('BROKEN');
    CANCELLED = new _Symbol('CANCELLED');
    SEGMENT_SIZE = systemProp('kotlinx.coroutines.semaphore.segmentSize', 16);
  }
}
function createDefaultDispatcher() {
  var tmp;
  if (isJsdom()) {
    tmp = NodeDispatcher_getInstance();
  } else {
    var tmp_0;
    var tmp_1;
    if (!(typeof window === 'undefined')) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = window != null;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = !(typeof window.addEventListener === 'undefined');
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = asCoroutineDispatcher(window);
    } else {
      if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
        tmp = SetTimeoutDispatcher_getInstance();
      } else {
        tmp = NodeDispatcher_getInstance();
      }
    }
  }
  return tmp;
}
function isJsdom() {
  return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
}
var counter;
function get_DEBUG() {
  return DEBUG;
}
var DEBUG;
function get_classSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).u9();
  return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
}
function get_hexAddress(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var result = _this__u8e3s4.__debug_counter;
  if (!(typeof result === 'number')) {
    counter = counter + 1 | 0;
    result = counter;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.__debug_counter = result;
  }
  return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
}
function NodeDispatcher() {
  NodeDispatcher_instance = this;
  SetTimeoutBasedDispatcher.call(this);
}
protoOf(NodeDispatcher).s1q = function () {
  process.nextTick(this.z1q_1.x1q_1);
};
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance == null) new NodeDispatcher();
  return NodeDispatcher_instance;
}
function ScheduledMessageQueue$processQueue$lambda(this$0) {
  return function () {
    this$0.d1r();
    return Unit_instance;
  };
}
function ScheduledMessageQueue(dispatcher) {
  MessageQueue.call(this);
  this.w1q_1 = dispatcher;
  var tmp = this;
  tmp.x1q_1 = ScheduledMessageQueue$processQueue$lambda(this);
}
protoOf(ScheduledMessageQueue).e1r = function () {
  this.w1q_1.s1q();
};
protoOf(ScheduledMessageQueue).f1r = function () {
  setTimeout(this.x1q_1, 0);
};
protoOf(ScheduledMessageQueue).g1r = function (timeout) {
  setTimeout(this.x1q_1, timeout);
};
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
function WindowMessageQueue$lambda(this$0) {
  return function (event) {
    if (event.source == this$0.n1r_1 && event.data == this$0.o1r_1) {
      event.stopPropagation();
      this$0.d1r();
    }
    return Unit_instance;
  };
}
function WindowMessageQueue$schedule$lambda(this$0) {
  return function (it) {
    this$0.d1r();
    return Unit_instance;
  };
}
function WindowMessageQueue(window_0) {
  MessageQueue.call(this);
  this.n1r_1 = window_0;
  this.o1r_1 = 'dispatchCoroutine';
  this.n1r_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
}
protoOf(WindowMessageQueue).e1r = function () {
  var tmp = Promise.resolve(Unit_instance);
  tmp.then(WindowMessageQueue$schedule$lambda(this));
};
protoOf(WindowMessageQueue).f1r = function () {
  this.n1r_1.postMessage(this.o1r_1, '*');
};
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
function promise(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  return asPromise(async(_this__u8e3s4, context, start, block));
}
function await_0(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.p1i();
  // Inline function 'kotlinx.coroutines.await.<anonymous>' call
  var tmp = await$lambda(cancellable);
  _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
  return cancellable.z1i();
}
function asPromise(_this__u8e3s4) {
  var promise = new Promise(asPromise$lambda(_this__u8e3s4));
  // Inline function 'kotlin.js.asDynamic' call
  promise.deferred = _this__u8e3s4;
  return promise;
}
function await$lambda($cont) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function await$lambda_0($cont) {
  return function (it) {
    var tmp0 = $cont;
    var tmp0_elvis_lhs = it instanceof Error ? it : null;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = tmp0_elvis_lhs == null ? Exception_init_$Create$_0('Non-Kotlin exception ' + it.toString()) : tmp0_elvis_lhs;
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function asPromise$lambda$lambda($this_asPromise, $reject, $resolve) {
  return function (it) {
    var e = $this_asPromise.l1g();
    if (!(e == null)) {
      $reject(e);
    } else {
      $resolve($this_asPromise.y1g());
    }
    return Unit_instance;
  };
}
function asPromise$lambda($this_asPromise) {
  return function (resolve, reject) {
    $this_asPromise.v1f(asPromise$lambda$lambda($this_asPromise, reject, resolve));
    return Unit_instance;
  };
}
function asCoroutineDispatcher(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = new WindowDispatcher(_this__u8e3s4);
    // Inline function 'kotlinx.coroutines.asCoroutineDispatcher.<anonymous>' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.coroutineDispatcher = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function propagateExceptionFinalResort(exception) {
  console.error(exception.toString());
}
function createEventLoop() {
  return new UnconfinedEventLoop();
}
function UnconfinedEventLoop() {
  EventLoop.call(this);
}
protoOf(UnconfinedEventLoop).k1k = function (context, block) {
  unsupported();
};
function unsupported() {
  throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
}
function SetTimeoutDispatcher() {
  SetTimeoutDispatcher_instance = this;
  SetTimeoutBasedDispatcher.call(this);
}
protoOf(SetTimeoutDispatcher).s1q = function () {
  this.z1q_1.g1r(0);
};
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance == null) new SetTimeoutDispatcher();
  return SetTimeoutDispatcher_instance;
}
function SetTimeoutBasedDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.n1j();
    return Unit_instance;
  };
}
function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlinx.coroutines.SetTimeoutBasedDispatcher.scheduleResumeAfterDelay.<anonymous>.<anonymous>' call
    $continuation.f1h(this$0, Unit_instance);
    return Unit_instance;
  };
}
function SetTimeoutBasedDispatcher() {
  CoroutineDispatcher.call(this);
  this.z1q_1 = new ScheduledMessageQueue(this);
}
protoOf(SetTimeoutBasedDispatcher).k1k = function (context, block) {
  this.z1q_1.h1r(block);
};
protoOf(SetTimeoutBasedDispatcher).p1k = function (timeMillis, block, context) {
  var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
  return new ClearTimeout(handle);
};
protoOf(SetTimeoutBasedDispatcher).o1k = function (timeMillis, continuation) {
  var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
  invokeOnCancellation(continuation, new ClearTimeout(handle));
};
function MessageQueue() {
  this.a1r_1 = ArrayDeque_init_$Create$();
  this.b1r_1 = 16;
  this.c1r_1 = false;
}
protoOf(MessageQueue).h1r = function (element) {
  this.i1r(element);
  if (!this.c1r_1) {
    this.c1r_1 = true;
    this.e1r();
  }
};
protoOf(MessageQueue).d1r = function () {
  try {
    // Inline function 'kotlin.repeat' call
    var times = this.b1r_1;
    var inductionVariable = 0;
    if (inductionVariable < times) do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.coroutines.MessageQueue.process.<anonymous>' call
      var tmp0_elvis_lhs = removeFirstOrNull(this);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var element = tmp;
      element.n1j();
    } while (inductionVariable < times);
  } finally {
    if (this.n()) {
      this.c1r_1 = false;
    } else {
      this.f1r();
    }
  }
};
protoOf(MessageQueue).i1r = function (element) {
  return this.a1r_1.d(element);
};
protoOf(MessageQueue).d = function (element) {
  return this.i1r((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).j1r = function (elements) {
  return this.a1r_1.o(elements);
};
protoOf(MessageQueue).o = function (elements) {
  return this.j1r(elements);
};
protoOf(MessageQueue).y1 = function (index) {
  return this.a1r_1.y1(index);
};
protoOf(MessageQueue).n = function () {
  return this.a1r_1.n();
};
protoOf(MessageQueue).i = function () {
  return this.a1r_1.i();
};
protoOf(MessageQueue).m = function (index) {
  return this.a1r_1.m(index);
};
protoOf(MessageQueue).l = function () {
  return this.a1r_1.ac_1;
};
function WindowClearTimeout($outer, handle) {
  this.w1r_1 = $outer;
  ClearTimeout.call(this, handle);
}
protoOf(WindowClearTimeout).q1i = function () {
  w3cClearTimeout(this.w1r_1.y1r_1, this.a1s_1);
};
function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlinx.coroutines.WindowDispatcher.scheduleResumeAfterDelay.<anonymous>.<anonymous>' call
    $continuation.f1h(this$0, Unit_instance);
    return Unit_instance;
  };
}
function Runnable$run$ref($boundThis) {
  var l = function l() {
    $boundThis.n1j();
    return Unit_instance;
  };
  l.callableName = 'run';
  return l;
}
function WindowDispatcher(window_0) {
  CoroutineDispatcher.call(this);
  this.y1r_1 = window_0;
  this.z1r_1 = new WindowMessageQueue(this.y1r_1);
}
protoOf(WindowDispatcher).k1k = function (context, block) {
  return this.z1r_1.h1r(block);
};
protoOf(WindowDispatcher).o1k = function (timeMillis, continuation) {
  var handle = w3cSetTimeout_0(this.y1r_1, WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
  invokeOnCancellation(continuation, new WindowClearTimeout(this, handle));
};
protoOf(WindowDispatcher).p1k = function (timeMillis, block, context) {
  var handle = w3cSetTimeout_0(this.y1r_1, Runnable$run$ref(block), delayToInt(timeMillis));
  return new WindowClearTimeout(this, handle);
};
function delayToInt(timeMillis) {
  return coerceIn(timeMillis, new Long(0, 0), new Long(2147483647, 0)).b1();
}
function ClearTimeout(handle) {
  this.a1s_1 = handle;
}
protoOf(ClearTimeout).q1i = function () {
  w3cClearTimeout_0(this.a1s_1);
};
protoOf(ClearTimeout).w1i = function (cause) {
  this.q1i();
};
protoOf(ClearTimeout).toString = function () {
  return 'ClearTimeout[' + this.a1s_1 + ']';
};
function toDebugString(_this__u8e3s4) {
  return toString_1(_this__u8e3s4);
}
function get_DefaultDelay() {
  var tmp = Dispatchers_getInstance().k1n_1;
  return isInterface(tmp, Delay) ? tmp : THROW_CCE();
}
function newCoroutineContext(_this__u8e3s4, context) {
  var combined = _this__u8e3s4.u1e().ld(context);
  return !(combined === Dispatchers_getInstance().k1n_1) && combined.s8(Key_instance) == null ? combined.ld(Dispatchers_getInstance().k1n_1) : combined;
}
function get_coroutineName(_this__u8e3s4) {
  return null;
}
function Dispatchers() {
  Dispatchers_instance = this;
  this.k1n_1 = createDefaultDispatcher();
  this.l1n_1 = Unconfined_getInstance();
  this.m1n_1 = new JsMainDispatcher(this.k1n_1, false);
  this.n1n_1 = null;
}
protoOf(Dispatchers).o1n = function () {
  var tmp0_elvis_lhs = this.n1n_1;
  return tmp0_elvis_lhs == null ? this.m1n_1 : tmp0_elvis_lhs;
};
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance == null) new Dispatchers();
  return Dispatchers_instance;
}
function JsMainDispatcher(delegate, invokeImmediately) {
  MainCoroutineDispatcher.call(this);
  this.c1s_1 = delegate;
  this.d1s_1 = invokeImmediately;
  this.e1s_1 = this.d1s_1 ? this : new JsMainDispatcher(this.c1s_1, true);
}
protoOf(JsMainDispatcher).i1n = function () {
  return this.e1s_1;
};
protoOf(JsMainDispatcher).j1k = function (context) {
  return !this.d1s_1;
};
protoOf(JsMainDispatcher).k1k = function (context, block) {
  return this.c1s_1.k1k(context, block);
};
protoOf(JsMainDispatcher).toString = function () {
  var tmp0_elvis_lhs = this.j1n();
  return tmp0_elvis_lhs == null ? this.c1s_1.toString() : tmp0_elvis_lhs;
};
function JobCancellationException(message, cause, job) {
  CancellationException_init_$Init$_1(message, cause, this);
  captureStack(this, JobCancellationException);
  this.f1s_1 = job;
}
protoOf(JobCancellationException).toString = function () {
  return protoOf(CancellationException).toString.call(this) + '; job=' + toString_1(this.f1s_1);
};
protoOf(JobCancellationException).equals = function (other) {
  var tmp;
  if (other === this) {
    tmp = true;
  } else {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof JobCancellationException) {
      tmp_2 = other.message == this.message;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = equals(other.f1s_1, this.f1s_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(other.cause, this.cause);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(JobCancellationException).hashCode = function () {
  var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.f1s_1) | 0, 31);
  var tmp0_safe_receiver = this.cause;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
};
function Runnable() {}
function SchedulerTask() {}
function identitySet(expectedSize) {
  return HashSet_init_$Create$_1(expectedSize);
}
function get_platformExceptionHandlers_() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return platformExceptionHandlers_;
}
var platformExceptionHandlers_;
function get_platformExceptionHandlers() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return get_platformExceptionHandlers_();
}
function DiagnosticCoroutineContextException(context) {
  RuntimeException_init_$Init$_0(toString_1(context), this);
  captureStack(this, DiagnosticCoroutineContextException);
}
var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
  if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
    properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    platformExceptionHandlers_ = LinkedHashSet_init_$Create$();
  }
}
function LockFreeLinkedListHead() {
  LockFreeLinkedListNode.call(this);
}
function LockFreeLinkedListNode() {
  this.c1k_1 = this;
  this.d1k_1 = this;
  this.e1k_1 = false;
}
protoOf(LockFreeLinkedListNode).f1k = function (node, permissionsBitmask) {
  var prev = this.d1k_1;
  var tmp;
  if (prev instanceof ListClosed) {
    tmp = (prev.j1s_1 & permissionsBitmask) === 0 && prev.f1k(node, permissionsBitmask);
  } else {
    node.c1k_1 = this;
    node.d1k_1 = prev;
    prev.c1k_1 = node;
    this.d1k_1 = node;
    tmp = true;
  }
  return tmp;
};
protoOf(LockFreeLinkedListNode).r1l = function (forbiddenElementsBit) {
  this.f1k(new ListClosed(forbiddenElementsBit), forbiddenElementsBit);
};
protoOf(LockFreeLinkedListNode).g1k = function () {
  if (this.e1k_1) return false;
  var prev = this.d1k_1;
  var next = this.c1k_1;
  prev.c1k_1 = next;
  next.d1k_1 = prev;
  this.e1k_1 = true;
  return true;
};
protoOf(LockFreeLinkedListNode).h1k = function (node) {
  if (!(this.c1k_1 === this)) return false;
  this.f1k(node, -2147483648);
  return true;
};
function ListClosed(forbiddenElementsBitmask) {
  LockFreeLinkedListNode.call(this);
  this.j1s_1 = forbiddenElementsBitmask;
}
function unwrap(exception) {
  return exception;
}
function recoverStackTrace(exception, continuation) {
  return exception;
}
function SynchronizedObject() {}
function threadContextElements(context) {
  return 0;
}
function CommonThreadLocal() {
  this.e1l_1 = null;
}
protoOf(CommonThreadLocal).f1l = function () {
  var tmp = this.e1l_1;
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(CommonThreadLocal).g1l = function (value) {
  this.e1l_1 = value;
};
function commonThreadLocal(name) {
  return new CommonThreadLocal();
}
//region block: post-declaration
protoOf(JobSupport).ld = plus;
protoOf(JobSupport).s8 = get;
protoOf(JobSupport).kd = fold;
protoOf(JobSupport).jd = minusKey;
protoOf(CoroutineDispatcher).s8 = get_0;
protoOf(CoroutineDispatcher).jd = minusKey_0;
defineProp(protoOf(DispatchException), 'cause', function () {
  return this.w8();
});
//endregion
//region block: init
Active_instance = new Active();
Key_instance_1 = new Key_0();
Key_instance_2 = new Key_1();
NonDisposableHandle_instance = new NonDisposableHandle();
Key_instance_3 = new Key_2();
counter = 0;
DEBUG = false;
//endregion

export { CoroutineScope as CoroutineScopefcb5f5dwqcas, CoroutineScope_0 as CoroutineScopelux7s7zphw7e, Mutex as Mutex16li1l0asjv17, SupervisorJob as SupervisorJobythnfxkr3jxc, await_0 as awaitopqeg9l1dqx0, delay as delayko55i6ibvfeo, launch as launch1c91vkjzdi9sd, promise as promise1ky6tawqaxbt4, withTimeoutOrNull as withTimeoutOrNullod8v51lxlhk };
